// Generated from ./util_cohort_builder_grammar/stable/DerivedEvents.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";

import { DerivedEventsListener } from "./DerivedEventsListener.js";
import { DerivedEventsVisitor } from "./DerivedEventsVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;


export class DerivedEvents extends antlr.Parser {
    public static readonly DERIVED_EVENT_DATE = 1;
    public static readonly CONSTRAINTS = 2;
    public static readonly ANY_ORDER = 3;
    public static readonly IS_EVENT_DATE = 4;
    public static readonly TC = 5;
    public static readonly TEMPORAL_CONSTRAINT_ABBR = 6;
    public static readonly TEMPORAL_CONSTRAINT = 7;
    public static readonly POSITION = 8;
    public static readonly CF = 9;
    public static readonly CONCEPT_FILTER = 10;
    public static readonly CONCEPT_FILTER_ABBR = 11;
    public static readonly NF = 12;
    public static readonly NUMERIC_FILTER = 13;
    public static readonly NUMERIC_FILTER_ABBR = 14;
    public static readonly SF = 15;
    public static readonly STRING_FILTER = 16;
    public static readonly STRING_FILTER_ABBR = 17;
    public static readonly UF = 18;
    public static readonly UNIQUENESS_FILTER = 19;
    public static readonly UNIQUENESS_FILTER_ABBR = 20;
    public static readonly RF = 21;
    public static readonly RELATED_ENTITY_FILTER = 22;
    public static readonly RELATED_ENTITY_FILTER_ABBR = 23;
    public static readonly QUALIFIED_CARE_SITE_ALIAS = 24;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE_ALIAS = 25;
    public static readonly QUALIFIED_DRUG_EXPOSURE_ALIAS = 26;
    public static readonly QUALIFIED_MEASUREMENT_ALIAS = 27;
    public static readonly QUALIFIED_OBSERVATION_ALIAS = 28;
    public static readonly QUALIFIED_PERSON_ALIAS = 29;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS = 30;
    public static readonly QUALIFIED_PROVIDER_ALIAS = 31;
    public static readonly QUALIFIED_VISIT_OCCURRENCE_ALIAS = 32;
    public static readonly QUALIFIED_DERIVED_EVENT_NAME = 33;
    public static readonly SUBJECT_VARIABLE_CARE_SITE_ALIAS = 34;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS = 35;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS = 36;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT_ALIAS = 37;
    public static readonly SUBJECT_VARIABLE_OBSERVATION_ALIAS = 38;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS = 39;
    public static readonly SUBJECT_VARIABLE_PROVIDER_ALIAS = 40;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS = 41;
    public static readonly SUBJECT_VARIABLE_DERIVED_EVENT_NAME = 42;
    public static readonly CONCEPT_GROUP = 43;
    public static readonly CARE_SITE_ALIAS = 44;
    public static readonly CONDITION_OCCURRENCE_ALIAS = 45;
    public static readonly DRUG_EXPOSURE_ALIAS = 46;
    public static readonly MEASUREMENT_ALIAS = 47;
    public static readonly OBSERVATION_ALIAS = 48;
    public static readonly PERSON_ALIAS = 49;
    public static readonly PROCEDURE_OCCURRENCE_ALIAS = 50;
    public static readonly PROVIDER_ALIAS = 51;
    public static readonly VISIT_OCCURRENCE_ALIAS = 52;
    public static readonly MERGED_EVENT_NAME = 53;
    public static readonly SEQUENCE_EVENT_NAME = 54;
    public static readonly INSTANCE_EVENT_NAME = 55;
    public static readonly SUBJECTS_VARIABLE_NAME = 56;
    public static readonly NAMESPACE_QUALIFIER = 57;
    public static readonly SUBJECTS_VARIABLE = 58;
    public static readonly CONCEPT = 59;
    public static readonly QUALIFIED_MERGED_EVENT = 60;
    public static readonly QUALIFIED_SEQUENCE_EVENT = 61;
    public static readonly QUALIFIED_INSTANCE_EVENT = 62;
    public static readonly SUBJECT_VARIABLE_MERGED_EVENT = 63;
    public static readonly SUBJECT_VARIABLE_SEQUENCE_EVENT = 64;
    public static readonly SUBJECT_VARIABLE_INSTANCE_EVENT = 65;
    public static readonly MERGED_EVENT = 66;
    public static readonly SEQUENCE_EVENT = 67;
    public static readonly INSTANCE_EVENT = 68;
    public static readonly DERIVED_EVENT = 69;
    public static readonly LINE_COMMENT = 70;
    public static readonly INT = 71;
    public static readonly M = 72;
    public static readonly D = 73;
    public static readonly Y = 74;
    public static readonly DATE = 75;
    public static readonly OPEN_PAREN = 76;
    public static readonly CLOSE_PAREN = 77;
    public static readonly SEMICOLON = 78;
    public static readonly COMMA = 79;
    public static readonly EQ = 80;
    public static readonly MULTIPLY = 81;
    public static readonly DIVIDE = 82;
    public static readonly ADD = 83;
    public static readonly SUBTRACT = 84;
    public static readonly CONTAINS = 85;
    public static readonly NEQ = 86;
    public static readonly LTE = 87;
    public static readonly GTE = 88;
    public static readonly LT = 89;
    public static readonly GT = 90;
    public static readonly MAX = 91;
    public static readonly MIN = 92;
    public static readonly AVG = 93;
    public static readonly COUNT = 94;
    public static readonly LEAST = 95;
    public static readonly GREATEST = 96;
    public static readonly IN = 97;
    public static readonly AND = 98;
    public static readonly OR = 99;
    public static readonly NOT = 100;
    public static readonly COMPLEMENT = 101;
    public static readonly UNION = 102;
    public static readonly INTERSECTION = 103;
    public static readonly DIFFERENCE = 104;
    public static readonly INDEX = 105;
    public static readonly TIME_UNIT = 106;
    public static readonly DAYS = 107;
    public static readonly WEEKS = 108;
    public static readonly MONTHS = 109;
    public static readonly YEARS = 110;
    public static readonly MINIMUM_BETWEEN = 111;
    public static readonly MAXIMUM_BETWEEN = 112;
    public static readonly TOTAL_BETWEEN = 113;
    public static readonly FIXED_WINDOW = 114;
    public static readonly ROLLING_WINDOW = 115;
    public static readonly PERIOD = 116;
    public static readonly WS = 117;
    public static readonly CARE_SITE = 118;
    public static readonly CONDITION_OCCURRENCE = 119;
    public static readonly DRUG_EXPOSURE = 120;
    public static readonly MEASUREMENT = 121;
    public static readonly OBSERVATION = 122;
    public static readonly PERSON = 123;
    public static readonly PROCEDURE_OCCURRENCE = 124;
    public static readonly PROVIDER = 125;
    public static readonly VISIT_OCCURRENCE = 126;
    public static readonly QUALIFIED_CARE_SITE = 127;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE = 128;
    public static readonly QUALIFIED_DRUG_EXPOSURE = 129;
    public static readonly QUALIFIED_MEASUREMENT = 130;
    public static readonly QUALIFIED_OBSERVATION = 131;
    public static readonly QUALIFIED_PERSON = 132;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE = 133;
    public static readonly QUALIFIED_PROVIDER = 134;
    public static readonly QUALIFIED_VISIT_OCCURRENCE = 135;
    public static readonly SUBJECT_VARIABLE_CARE_SITE = 136;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE = 137;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE = 138;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT = 139;
    public static readonly SUBJECT_VARIABLE_OBSERVATION = 140;
    public static readonly SUBJECT_VARIABLE_PERSON = 141;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE = 142;
    public static readonly SUBJECT_VARIABLE_PROVIDER = 143;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE = 144;
    public static readonly CONDITION_OCCURRENCE_DATE_ATTRIBUTE = 145;
    public static readonly DRUG_EXPOSURE_DATE_ATTRIBUTE = 146;
    public static readonly MEASUREMENT_DATE_ATTRIBUTE = 147;
    public static readonly OBSERVATION_DATE_ATTRIBUTE = 148;
    public static readonly PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE = 149;
    public static readonly VISIT_OCCURRENCE_DATE_ATTRIBUTE = 150;
    public static readonly PERSON_DATE_TIME_ATTRIBUTE = 151;
    public static readonly DRUG_EXPOSURE_INT_ATTRIBUTE = 152;
    public static readonly MEASUREMENT_FLOAT_ATTRIBUTE = 153;
    public static readonly PERSON_INT_ATTRIBUTE = 154;
    public static readonly COMMON_NUMERIC_FLOAT_ATTRIBUTE = 155;
    public static readonly QUANTITY = 156;
    public static readonly CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE = 157;
    public static readonly DRUG_EXPOSURE_CONCEPT_ATTRIBUTE = 158;
    public static readonly MEASUREMENT_CONCEPT_ATTRIBUTE = 159;
    public static readonly OBSERVATION_CONCEPT_ATTRIBUTE = 160;
    public static readonly PERSON_CONCEPT_ATTRIBUTE = 161;
    public static readonly PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE = 162;
    public static readonly PROVIDER_CONCEPT_ATTRIBUTE = 163;
    public static readonly VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE = 164;
    public static readonly COMMON_CONCEPT_ATTRIBUTE = 165;
    public static readonly CARE_SITE_CONCEPT_ATTRIBUTE = 166;
    public static readonly COMMON_STRING_ATTRIBUTE = 167;
    public static readonly GENDER_SOURCE_VALUE = 168;
    public static readonly CARE_SITE_STRING_ATTRIBUTE = 169;
    public static readonly CONDITION_OCCURRENCE_STRING_ATTRIBUTE = 170;
    public static readonly DRUG_EXPOSURE_STRING_ATTRIBUTE = 171;
    public static readonly MEASUREMENT_STRING_ATTRIBUTE = 172;
    public static readonly OBSERVATION_STRING_ATTRIBUTE = 173;
    public static readonly PERSON_STRING_ATTRIBUTE = 174;
    public static readonly PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE = 175;
    public static readonly PROVIDER_STRING_ATTRIBUTE = 176;
    public static readonly VISIT_OCCURRENCE_STRING_ATTRIBUTE = 177;
    public static readonly RULE_derived_event = 0;
    public static readonly RULE_merged_event = 1;
    public static readonly RULE_merged_event_criteria = 2;
    public static readonly RULE_merged_event_criterion = 3;
    public static readonly RULE_merged_event_filter_criterion = 4;
    public static readonly RULE_merged_event_event = 5;
    public static readonly RULE_merged_event_filter = 6;
    public static readonly RULE_merged_event_uniqueness_filter = 7;
    public static readonly RULE_merged_event_uniqueness_filter_criteria = 8;
    public static readonly RULE_merged_event_filter_error = 9;
    public static readonly RULE_sequence_event = 10;
    public static readonly RULE_sequence_event_criteria = 11;
    public static readonly RULE_sequence_event_criterion = 12;
    public static readonly RULE_sequence_event_constraint = 13;
    public static readonly RULE_temporal_constraint = 14;
    public static readonly RULE_sequence_temporal_filter = 15;
    public static readonly RULE_sequence_event_event = 16;
    public static readonly RULE_selected_sequence_event = 17;
    public static readonly RULE_unselected_sequence_event = 18;
    public static readonly RULE_instance_event = 19;
    public static readonly RULE_instance_event_criteria = 20;
    public static readonly RULE_instance_event_criterion = 21;
    public static readonly RULE_instance_event_event = 22;
    public static readonly RULE_instance_event_position = 23;
    public static readonly RULE_aggregation_qualified = 24;
    public static readonly RULE_specific_instance = 25;
    public static readonly RULE_instance_event_position_error = 26;
    public static readonly RULE_qualified_simple_event = 27;
    public static readonly RULE_qualified_derived_event = 28;
    public static readonly RULE_sequence_event_constraint_error = 29;
    public static readonly RULE_derived_event_error = 30;
    public static readonly RULE_derived_uniqueness_filter = 31;
    public static readonly RULE_derived_uniqueness_filter_window = 32;
    public static readonly RULE_derived_fixed_window_uniqueness_filter = 33;
    public static readonly RULE_derived_rolling_window_uniqueness_filter = 34;
    public static readonly RULE_derived_event_int = 35;
    public static readonly RULE_simple_event = 36;
    public static readonly RULE_condition_occurrence_event = 37;
    public static readonly RULE_drug_exposure_event = 38;
    public static readonly RULE_measurement_event = 39;
    public static readonly RULE_observation_event = 40;
    public static readonly RULE_procedure_occurrence_event = 41;
    public static readonly RULE_visit_occurrence_event = 42;
    public static readonly RULE_condition_occurrence_event_definition = 43;
    public static readonly RULE_drug_exposure_event_definition = 44;
    public static readonly RULE_measurement_event_definition = 45;
    public static readonly RULE_observation_event_definition = 46;
    public static readonly RULE_procedure_occurrence_event_definition = 47;
    public static readonly RULE_visit_occurrence_event_definition = 48;
    public static readonly RULE_condition_occurrence_event_criteria = 49;
    public static readonly RULE_condition_occurrence_event_filter = 50;
    public static readonly RULE_condition_occurrence_concept_filters = 51;
    public static readonly RULE_condition_occurrence_concept_group_filter = 52;
    public static readonly RULE_condition_occurrence_concept_filter = 53;
    public static readonly RULE_condition_occurrence_uniqueness_filters = 54;
    public static readonly RULE_condition_occurrence_uniqueness_filter = 55;
    public static readonly RULE_condition_occurrence_related_entity_filters = 56;
    public static readonly RULE_condition_occurrence_related_entity_filter = 57;
    public static readonly RULE_condition_occurrence_sub_filter = 58;
    public static readonly RULE_condition_occurrence_error_sub_filter = 59;
    public static readonly RULE_condition_occurrence_error_filter = 60;
    public static readonly RULE_drug_exposure_event_criteria = 61;
    public static readonly RULE_drug_exposure_event_filter = 62;
    public static readonly RULE_drug_exposure_concept_filters = 63;
    public static readonly RULE_drug_exposure_concept_group_filter = 64;
    public static readonly RULE_drug_exposure_concept_filter = 65;
    public static readonly RULE_drug_exposure_numeric_filters = 66;
    public static readonly RULE_drug_exposure_float_filter = 67;
    public static readonly RULE_drug_exposure_int_filter = 68;
    public static readonly RULE_drug_exposure_uniqueness_filters = 69;
    public static readonly RULE_drug_exposure_uniqueness_filter = 70;
    public static readonly RULE_drug_exposure_related_entity_filters = 71;
    public static readonly RULE_drug_exposure_related_entity_filter = 72;
    public static readonly RULE_drug_exposure_error_filter = 73;
    public static readonly RULE_measurement_event_criteria = 74;
    public static readonly RULE_measurement_event_filter = 75;
    public static readonly RULE_measurement_concept_filters = 76;
    public static readonly RULE_measurement_concept_group_filter = 77;
    public static readonly RULE_measurement_concept_filter = 78;
    public static readonly RULE_measurement_numeric_filters = 79;
    public static readonly RULE_measurement_float_filter = 80;
    public static readonly RULE_measurement_uniqueness_filters = 81;
    public static readonly RULE_measurement_uniqueness_filter = 82;
    public static readonly RULE_measurement_related_entity_filters = 83;
    public static readonly RULE_measurement_related_entity_filter = 84;
    public static readonly RULE_measurement_error_filter = 85;
    public static readonly RULE_observation_event_criteria = 86;
    public static readonly RULE_observation_event_filter = 87;
    public static readonly RULE_observation_concept_filters = 88;
    public static readonly RULE_observation_concept_group_filter = 89;
    public static readonly RULE_observation_concept_filter = 90;
    public static readonly RULE_observation_numeric_filters = 91;
    public static readonly RULE_observation_float_filter = 92;
    public static readonly RULE_observation_uniqueness_filters = 93;
    public static readonly RULE_observation_uniqueness_filter = 94;
    public static readonly RULE_observation_related_entity_filters = 95;
    public static readonly RULE_observation_related_entity_filter = 96;
    public static readonly RULE_observation_error_filter = 97;
    public static readonly RULE_procedure_occurrence_event_criteria = 98;
    public static readonly RULE_procedure_occurrence_event_filter = 99;
    public static readonly RULE_procedure_occurrence_concept_filters = 100;
    public static readonly RULE_procedure_occurrence_concept_group_filter = 101;
    public static readonly RULE_procedure_occurrence_concept_filter = 102;
    public static readonly RULE_procedure_occurrence_numeric_filters = 103;
    public static readonly RULE_procedure_occurrence_int_filter = 104;
    public static readonly RULE_procedure_occurrence_uniqueness_filters = 105;
    public static readonly RULE_procedure_occurrence_uniqueness_filter = 106;
    public static readonly RULE_procedure_occurrence_related_entity_filters = 107;
    public static readonly RULE_procedure_occurrence_related_entity_filter = 108;
    public static readonly RULE_procedure_occurrence_error_filter = 109;
    public static readonly RULE_provider_concept_filters = 110;
    public static readonly RULE_provider_concept_group_filter = 111;
    public static readonly RULE_provider_concept_filter = 112;
    public static readonly RULE_provider_sub_filter = 113;
    public static readonly RULE_provider_error_sub_filter = 114;
    public static readonly RULE_visit_occurrence_event_criteria = 115;
    public static readonly RULE_visit_occurrence_event_filter = 116;
    public static readonly RULE_visit_occurrence_concept_filters = 117;
    public static readonly RULE_visit_occurrence_concept_group_filter = 118;
    public static readonly RULE_visit_occurrence_concept_filter = 119;
    public static readonly RULE_visit_occurrence_uniqueness_filters = 120;
    public static readonly RULE_visit_occurrence_uniqueness_filter = 121;
    public static readonly RULE_visit_occurrence_related_entity_filters = 122;
    public static readonly RULE_visit_occurrence_related_entity_filter = 123;
    public static readonly RULE_visit_occurrence_sub_filter = 124;
    public static readonly RULE_visit_occurrence_error_sub_filter = 125;
    public static readonly RULE_visit_occurrence_error_filter = 126;
    public static readonly RULE_comparison_op = 127;
    public static readonly RULE_simple_uniqueness_filter = 128;
    public static readonly RULE_simple_uniqueness_filter_window = 129;
    public static readonly RULE_fixed_window_uniqueness_filter = 130;
    public static readonly RULE_rolling_window_uniqueness_filter = 131;
    public static readonly RULE_simple_event_float = 132;
    public static readonly RULE_simple_event_int = 133;
    public static readonly RULE_concept_group_selection = 134;

    public static readonly literalNames = [
        null, "'derived_event_date'", "'CONSTRAINTS'", "'ANY_ORDER'", "'IS_EVENT_DATE'", 
        null, "'TC'", "'TEMPORAL_CONSTRAINT'", "'POSITION'", null, "'CONCEPT_FILTER'", 
        "'CF'", null, "'NUMERIC_FILTER'", "'NF'", null, "'STRING_FILTER'", 
        "'SF'", null, "'UNIQUENESS_FILTER'", "'UF'", null, "'RELATED_ENTITY_FILTER'", 
        "'RF'", null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, "'::'", "'SUBJECTS_VARIABLE'", null, "'QUALIFIED_MERGED_EVENT'", 
        "'QUALIFIED_SEQUENCE_EVENT'", "'QUALIFIED_INSTANCE_EVENT'", "'SUBJECT_VARIABLE_MERGED_EVENT'", 
        "'SUBJECT_VARIABLE_SEQUENCE_EVENT'", "'SUBJECT_VARIABLE_INSTANCE_EVENT'", 
        "'MERGED_EVENT'", "'SEQUENCE_EVENT'", "'INSTANCE_EVENT'", "'DERIVED_EVENT'", 
        null, null, null, null, null, null, "'('", "')'", "';'", "','", 
        "'='", "'*'", "'/'", "'+'", "'-'", "'CONTAINS'", "'!='", "'<='", 
        "'>='", "'<'", "'>'", "'MAX'", "'MIN'", "'AVG'", "'COUNT'", "'LEAST'", 
        "'GREATEST'", "'IN'", "'AND'", "'OR'", "'NOT'", "'COMPLEMENT'", 
        "'UNION'", "'INTERSECTION'", "'DIFFERENCE'", "'INDEX'", null, "'DAYS'", 
        "'WEEKS'", "'MONTHS'", "'YEARS'", "'MINIMUM_BETWEEN'", "'MAXIMUM_BETWEEN'", 
        "'TOTAL_BETWEEN'", "'FIXED_WINDOW'", "'ROLLING_WINDOW'", "'.'", 
        null, "'CARE_SITE'", "'CONDITION_OCCURRENCE'", "'DRUG_EXPOSURE'", 
        "'MEASUREMENT'", "'OBSERVATION'", "'PERSON'", "'PROCEDURE_OCCURRENCE'", 
        "'PROVIDER'", "'VISIT_OCCURRENCE'", "'QUALIFIED_CARE_SITE'", "'QUALIFIED_CONDITION_OCCURRENCE'", 
        "'QUALIFIED_DRUG_EXPOSURE'", "'QUALIFIED_MEASUREMENT'", "'QUALIFIED_OBSERVATION'", 
        "'QUALIFIED_PERSON'", "'QUALIFIED_PROCEDURE_OCCURRENCE'", "'QUALIFIED_PROVIDER'", 
        "'QUALIFIED_VISIT_OCCURRENCE'", "'SUBJECT_VARIABLE_CARE_SITE'", 
        "'SUBJECT_VARIABLE_CONDITION_OCCURRENCE'", "'SUBJECT_VARIABLE_DRUG_EXPOSURE'", 
        "'SUBJECT_VARIABLE_MEASUREMENT'", "'SUBJECT_VARIABLE_OBSERVATION'", 
        "'SUBJECT_VARIABLE_PERSON'", "'SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE'", 
        "'SUBJECT_VARIABLE_PROVIDER'", "'SUBJECT_VARIABLE_VISIT_OCCURRENCE'", 
        null, null, "'measurement_date'", "'observation_date'", "'procedure_date'", 
        null, "'birth_datetime'", null, null, null, "'value_as_number'", 
        "'quantity'", null, null, null, null, null, null, "'specialty_concept'", 
        null, null, "'place_of_service_concept'", "'value_as_string'", "'gender_source_value'"
    ];

    public static readonly symbolicNames = [
        null, "DERIVED_EVENT_DATE", "CONSTRAINTS", "ANY_ORDER", "IS_EVENT_DATE", 
        "TC", "TEMPORAL_CONSTRAINT_ABBR", "TEMPORAL_CONSTRAINT", "POSITION", 
        "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", "NF", "NUMERIC_FILTER", 
        "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", "STRING_FILTER_ABBR", 
        "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", "RF", "RELATED_ENTITY_FILTER", 
        "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", 
        "QUALIFIED_DRUG_EXPOSURE_ALIAS", "QUALIFIED_MEASUREMENT_ALIAS", 
        "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", 
        "QUALIFIED_PROVIDER_ALIAS", "QUALIFIED_VISIT_OCCURRENCE_ALIAS", 
        "QUALIFIED_DERIVED_EVENT_NAME", "SUBJECT_VARIABLE_CARE_SITE_ALIAS", 
        "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", 
        "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", "SUBJECT_VARIABLE_OBSERVATION_ALIAS", 
        "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_PROVIDER_ALIAS", 
        "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", 
        "CONCEPT_GROUP", "CARE_SITE_ALIAS", "CONDITION_OCCURRENCE_ALIAS", 
        "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", "OBSERVATION_ALIAS", 
        "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", "PROVIDER_ALIAS", 
        "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", "SEQUENCE_EVENT_NAME", 
        "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", "NAMESPACE_QUALIFIER", 
        "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", "QUALIFIED_SEQUENCE_EVENT", 
        "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", "SUBJECT_VARIABLE_SEQUENCE_EVENT", 
        "SUBJECT_VARIABLE_INSTANCE_EVENT", "MERGED_EVENT", "SEQUENCE_EVENT", 
        "INSTANCE_EVENT", "DERIVED_EVENT", "LINE_COMMENT", "INT", "M", "D", 
        "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", "SEMICOLON", "COMMA", 
        "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", "CONTAINS", "NEQ", 
        "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", "COUNT", "LEAST", 
        "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", "UNION", "INTERSECTION", 
        "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", "WEEKS", "MONTHS", "YEARS", 
        "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", "TOTAL_BETWEEN", "FIXED_WINDOW", 
        "ROLLING_WINDOW", "PERIOD", "WS", "CARE_SITE", "CONDITION_OCCURRENCE", 
        "DRUG_EXPOSURE", "MEASUREMENT", "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", 
        "PROVIDER", "VISIT_OCCURRENCE", "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", 
        "QUALIFIED_DRUG_EXPOSURE", "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", 
        "QUALIFIED_PERSON", "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", 
        "QUALIFIED_VISIT_OCCURRENCE", "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE"
    ];
    public static readonly ruleNames = [
        "derived_event", "merged_event", "merged_event_criteria", "merged_event_criterion", 
        "merged_event_filter_criterion", "merged_event_event", "merged_event_filter", 
        "merged_event_uniqueness_filter", "merged_event_uniqueness_filter_criteria", 
        "merged_event_filter_error", "sequence_event", "sequence_event_criteria", 
        "sequence_event_criterion", "sequence_event_constraint", "temporal_constraint", 
        "sequence_temporal_filter", "sequence_event_event", "selected_sequence_event", 
        "unselected_sequence_event", "instance_event", "instance_event_criteria", 
        "instance_event_criterion", "instance_event_event", "instance_event_position", 
        "aggregation_qualified", "specific_instance", "instance_event_position_error", 
        "qualified_simple_event", "qualified_derived_event", "sequence_event_constraint_error", 
        "derived_event_error", "derived_uniqueness_filter", "derived_uniqueness_filter_window", 
        "derived_fixed_window_uniqueness_filter", "derived_rolling_window_uniqueness_filter", 
        "derived_event_int", "simple_event", "condition_occurrence_event", 
        "drug_exposure_event", "measurement_event", "observation_event", 
        "procedure_occurrence_event", "visit_occurrence_event", "condition_occurrence_event_definition", 
        "drug_exposure_event_definition", "measurement_event_definition", 
        "observation_event_definition", "procedure_occurrence_event_definition", 
        "visit_occurrence_event_definition", "condition_occurrence_event_criteria", 
        "condition_occurrence_event_filter", "condition_occurrence_concept_filters", 
        "condition_occurrence_concept_group_filter", "condition_occurrence_concept_filter", 
        "condition_occurrence_uniqueness_filters", "condition_occurrence_uniqueness_filter", 
        "condition_occurrence_related_entity_filters", "condition_occurrence_related_entity_filter", 
        "condition_occurrence_sub_filter", "condition_occurrence_error_sub_filter", 
        "condition_occurrence_error_filter", "drug_exposure_event_criteria", 
        "drug_exposure_event_filter", "drug_exposure_concept_filters", "drug_exposure_concept_group_filter", 
        "drug_exposure_concept_filter", "drug_exposure_numeric_filters", 
        "drug_exposure_float_filter", "drug_exposure_int_filter", "drug_exposure_uniqueness_filters", 
        "drug_exposure_uniqueness_filter", "drug_exposure_related_entity_filters", 
        "drug_exposure_related_entity_filter", "drug_exposure_error_filter", 
        "measurement_event_criteria", "measurement_event_filter", "measurement_concept_filters", 
        "measurement_concept_group_filter", "measurement_concept_filter", 
        "measurement_numeric_filters", "measurement_float_filter", "measurement_uniqueness_filters", 
        "measurement_uniqueness_filter", "measurement_related_entity_filters", 
        "measurement_related_entity_filter", "measurement_error_filter", 
        "observation_event_criteria", "observation_event_filter", "observation_concept_filters", 
        "observation_concept_group_filter", "observation_concept_filter", 
        "observation_numeric_filters", "observation_float_filter", "observation_uniqueness_filters", 
        "observation_uniqueness_filter", "observation_related_entity_filters", 
        "observation_related_entity_filter", "observation_error_filter", 
        "procedure_occurrence_event_criteria", "procedure_occurrence_event_filter", 
        "procedure_occurrence_concept_filters", "procedure_occurrence_concept_group_filter", 
        "procedure_occurrence_concept_filter", "procedure_occurrence_numeric_filters", 
        "procedure_occurrence_int_filter", "procedure_occurrence_uniqueness_filters", 
        "procedure_occurrence_uniqueness_filter", "procedure_occurrence_related_entity_filters", 
        "procedure_occurrence_related_entity_filter", "procedure_occurrence_error_filter", 
        "provider_concept_filters", "provider_concept_group_filter", "provider_concept_filter", 
        "provider_sub_filter", "provider_error_sub_filter", "visit_occurrence_event_criteria", 
        "visit_occurrence_event_filter", "visit_occurrence_concept_filters", 
        "visit_occurrence_concept_group_filter", "visit_occurrence_concept_filter", 
        "visit_occurrence_uniqueness_filters", "visit_occurrence_uniqueness_filter", 
        "visit_occurrence_related_entity_filters", "visit_occurrence_related_entity_filter", 
        "visit_occurrence_sub_filter", "visit_occurrence_error_sub_filter", 
        "visit_occurrence_error_filter", "comparison_op", "simple_uniqueness_filter", 
        "simple_uniqueness_filter_window", "fixed_window_uniqueness_filter", 
        "rolling_window_uniqueness_filter", "simple_event_float", "simple_event_int", 
        "concept_group_selection",
    ];

    public get grammarFileName(): string { return "DerivedEvents.g4"; }
    public get literalNames(): (string | null)[] { return DerivedEvents.literalNames; }
    public get symbolicNames(): (string | null)[] { return DerivedEvents.symbolicNames; }
    public get ruleNames(): string[] { return DerivedEvents.ruleNames; }
    public get serializedATN(): number[] { return DerivedEvents._serializedATN; }

    protected createFailedPredicateException(predicate?: string, message?: string): antlr.FailedPredicateException {
        return new antlr.FailedPredicateException(this, predicate, message);
    }

    public constructor(input: antlr.TokenStream) {
        super(input);
        this.interpreter = new antlr.ParserATNSimulator(this, DerivedEvents._ATN, DerivedEvents.decisionsToDFA, new antlr.PredictionContextCache());
    }
    public derived_event(): Derived_eventContext {
        let localContext = new Derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 0, DerivedEvents.RULE_derived_event);
        try {
            this.state = 273;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.MERGED_EVENT_NAME:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 270;
                this.merged_event();
                }
                break;
            case DerivedEvents.SEQUENCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 271;
                this.sequence_event();
                }
                break;
            case DerivedEvents.INSTANCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 272;
                this.instance_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event(): Merged_eventContext {
        let localContext = new Merged_eventContext(this.context, this.state);
        this.enterRule(localContext, 2, DerivedEvents.RULE_merged_event);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 275;
            this.match(DerivedEvents.MERGED_EVENT_NAME);
            this.state = 276;
            this.match(DerivedEvents.EQ);
            this.state = 277;
            this.match(DerivedEvents.MERGED_EVENT);
            this.state = 278;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 279;
            this.merged_event_criteria();
            this.state = 282;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 79) {
                {
                this.state = 280;
                this.match(DerivedEvents.COMMA);
                this.state = 281;
                this.merged_event_filter_criterion();
                }
            }

            this.state = 284;
            this.match(DerivedEvents.CLOSE_PAREN);
            this.state = 285;
            this.match(DerivedEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        let localContext = new Merged_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 4, DerivedEvents.RULE_merged_event_criteria);
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 287;
            this.merged_event_criterion();
            this.state = 290;
            this.errorHandler.sync(this);
            alternative = 1;
            do {
                switch (alternative) {
                case 1:
                    {
                    {
                    this.state = 288;
                    this.match(DerivedEvents.COMMA);
                    this.state = 289;
                    this.merged_event_criterion();
                    }
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                this.state = 292;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 2, this.context);
            } while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criterion(): Merged_event_criterionContext {
        let localContext = new Merged_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 6, DerivedEvents.RULE_merged_event_criterion);
        try {
            this.state = 296;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 3, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 294;
                this.merged_event_event();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 295;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext {
        let localContext = new Merged_event_filter_criterionContext(this.context, this.state);
        this.enterRule(localContext, 8, DerivedEvents.RULE_merged_event_filter_criterion);
        try {
            this.state = 300;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 4, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 298;
                this.merged_event_filter();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 299;
                this.merged_event_filter_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_event(): Merged_event_eventContext {
        let localContext = new Merged_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 10, DerivedEvents.RULE_merged_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 302;
            this.match(DerivedEvents.DERIVED_EVENT);
            this.state = 303;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 306;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case DerivedEvents.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case DerivedEvents.QUALIFIED_MEASUREMENT_ALIAS:
            case DerivedEvents.QUALIFIED_OBSERVATION_ALIAS:
            case DerivedEvents.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case DerivedEvents.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 304;
                this.qualified_simple_event();
                }
                break;
            case DerivedEvents.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 305;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 308;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter(): Merged_event_filterContext {
        let localContext = new Merged_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 12, DerivedEvents.RULE_merged_event_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 310;
            this.merged_event_uniqueness_filter();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        let localContext = new Merged_event_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 14, DerivedEvents.RULE_merged_event_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 312;
            this.match(DerivedEvents.UF);
            this.state = 313;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 314;
            this.merged_event_uniqueness_filter_criteria();
            this.state = 315;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        let localContext = new Merged_event_uniqueness_filter_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 16, DerivedEvents.RULE_merged_event_uniqueness_filter_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 319;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.MINIMUM_BETWEEN:
                {
                this.state = 317;
                this.derived_uniqueness_filter();
                }
                break;
            case DerivedEvents.FIXED_WINDOW:
            case DerivedEvents.ROLLING_WINDOW:
                {
                this.state = 318;
                this.derived_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 321;
            localContext._date_attr = this.match(DerivedEvents.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext {
        let localContext = new Merged_event_filter_errorContext(this.context, this.state);
        this.enterRule(localContext, 18, DerivedEvents.RULE_merged_event_filter_error);
        try {
            this.state = 377;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 7, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 323;
                this.match(DerivedEvents.UF);
                this.state = 324;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 325;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 326;
                this.match(DerivedEvents.UF);
                this.state = 327;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 328;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 329;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 330;
                this.match(DerivedEvents.UF);
                this.state = 331;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 332;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 333;
                this.derived_event_int();
                this.state = 334;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 336;
                this.match(DerivedEvents.UF);
                this.state = 337;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 338;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 339;
                this.derived_event_int();
                this.state = 340;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 341;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 343;
                this.match(DerivedEvents.UF);
                this.state = 344;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 345;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 346;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 347;
                this.match(DerivedEvents.UF);
                this.state = 348;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 349;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 350;
                this.derived_event_int();
                this.state = 351;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 353;
                this.match(DerivedEvents.UF);
                this.state = 354;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 355;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 356;
                this.derived_event_int();
                this.state = 357;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 358;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 360;
                this.match(DerivedEvents.UF);
                this.state = 361;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 362;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 363;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 364;
                this.match(DerivedEvents.UF);
                this.state = 365;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 366;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 367;
                this.derived_event_int();
                this.state = 368;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 370;
                this.match(DerivedEvents.UF);
                this.state = 371;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 372;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 373;
                this.derived_event_int();
                this.state = 374;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 375;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event(): Sequence_eventContext {
        let localContext = new Sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 20, DerivedEvents.RULE_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 379;
            this.match(DerivedEvents.SEQUENCE_EVENT_NAME);
            this.state = 380;
            this.match(DerivedEvents.EQ);
            this.state = 381;
            this.match(DerivedEvents.SEQUENCE_EVENT);
            this.state = 382;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 383;
            this.sequence_event_criteria();
            this.state = 384;
            this.match(DerivedEvents.CLOSE_PAREN);
            this.state = 385;
            this.match(DerivedEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        let localContext = new Sequence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 22, DerivedEvents.RULE_sequence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 387;
            this.sequence_event_criterion();
            this.state = 392;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 79) {
                {
                {
                this.state = 388;
                this.match(DerivedEvents.COMMA);
                this.state = 389;
                this.sequence_event_criterion();
                }
                }
                this.state = 394;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criterion(): Sequence_event_criterionContext {
        let localContext = new Sequence_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 24, DerivedEvents.RULE_sequence_event_criterion);
        try {
            this.state = 399;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 9, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 395;
                this.sequence_event_constraint();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 396;
                this.sequence_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 397;
                this.sequence_event_constraint_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 398;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint(): Sequence_event_constraintContext {
        let localContext = new Sequence_event_constraintContext(this.context, this.state);
        this.enterRule(localContext, 26, DerivedEvents.RULE_sequence_event_constraint);
        try {
            this.state = 403;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.ANY_ORDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 401;
                this.match(DerivedEvents.ANY_ORDER);
                }
                break;
            case DerivedEvents.TC:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 402;
                this.temporal_constraint();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public temporal_constraint(): Temporal_constraintContext {
        let localContext = new Temporal_constraintContext(this.context, this.state);
        this.enterRule(localContext, 28, DerivedEvents.RULE_temporal_constraint);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 405;
            this.match(DerivedEvents.TC);
            this.state = 406;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 407;
            this.sequence_temporal_filter();
            this.state = 408;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        let localContext = new Sequence_temporal_filterContext(this.context, this.state);
        this.enterRule(localContext, 30, DerivedEvents.RULE_sequence_temporal_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 410;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 111)) & ~0x1F) === 0 && ((1 << (_la - 111)) & 7) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 411;
            this.match(DerivedEvents.INT);
            this.state = 412;
            this.match(DerivedEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_event(): Sequence_event_eventContext {
        let localContext = new Sequence_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 32, DerivedEvents.RULE_sequence_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 414;
            this.match(DerivedEvents.DERIVED_EVENT);
            this.state = 415;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 418;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 11, this.context) ) {
            case 1:
                {
                this.state = 416;
                this.selected_sequence_event();
                }
                break;
            case 2:
                {
                this.state = 417;
                this.unselected_sequence_event();
                }
                break;
            }
            this.state = 420;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public selected_sequence_event(): Selected_sequence_eventContext {
        let localContext = new Selected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 34, DerivedEvents.RULE_selected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 424;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case DerivedEvents.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case DerivedEvents.QUALIFIED_MEASUREMENT_ALIAS:
            case DerivedEvents.QUALIFIED_OBSERVATION_ALIAS:
            case DerivedEvents.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case DerivedEvents.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 422;
                this.qualified_simple_event();
                }
                break;
            case DerivedEvents.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 423;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 426;
            this.match(DerivedEvents.COMMA);
            this.state = 427;
            this.match(DerivedEvents.IS_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext {
        let localContext = new Unselected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 36, DerivedEvents.RULE_unselected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 431;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case DerivedEvents.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case DerivedEvents.QUALIFIED_MEASUREMENT_ALIAS:
            case DerivedEvents.QUALIFIED_OBSERVATION_ALIAS:
            case DerivedEvents.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case DerivedEvents.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 429;
                this.qualified_simple_event();
                }
                break;
            case DerivedEvents.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 430;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event(): Instance_eventContext {
        let localContext = new Instance_eventContext(this.context, this.state);
        this.enterRule(localContext, 38, DerivedEvents.RULE_instance_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 433;
            this.match(DerivedEvents.INSTANCE_EVENT_NAME);
            this.state = 434;
            this.match(DerivedEvents.EQ);
            this.state = 435;
            this.match(DerivedEvents.INSTANCE_EVENT);
            this.state = 436;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 437;
            this.instance_event_criteria();
            this.state = 438;
            this.match(DerivedEvents.CLOSE_PAREN);
            this.state = 439;
            this.match(DerivedEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        let localContext = new Instance_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 40, DerivedEvents.RULE_instance_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 441;
            this.instance_event_criterion();
            this.state = 444;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            do {
                {
                {
                this.state = 442;
                this.match(DerivedEvents.COMMA);
                this.state = 443;
                this.instance_event_criterion();
                }
                }
                this.state = 446;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            } while (_la === 79);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criterion(): Instance_event_criterionContext {
        let localContext = new Instance_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 42, DerivedEvents.RULE_instance_event_criterion);
        try {
            this.state = 453;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 15, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 449;
                this.instance_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 450;
                this.derived_event_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 451;
                this.instance_event_position();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 452;
                this.instance_event_position_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_event(): Instance_event_eventContext {
        let localContext = new Instance_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 44, DerivedEvents.RULE_instance_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 455;
            this.match(DerivedEvents.DERIVED_EVENT);
            this.state = 456;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 459;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case DerivedEvents.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case DerivedEvents.QUALIFIED_MEASUREMENT_ALIAS:
            case DerivedEvents.QUALIFIED_OBSERVATION_ALIAS:
            case DerivedEvents.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case DerivedEvents.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 457;
                this.qualified_simple_event();
                }
                break;
            case DerivedEvents.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 458;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 461;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position(): Instance_event_positionContext {
        let localContext = new Instance_event_positionContext(this.context, this.state);
        this.enterRule(localContext, 46, DerivedEvents.RULE_instance_event_position);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 463;
            this.match(DerivedEvents.POSITION);
            this.state = 464;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 467;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.MAX:
            case DerivedEvents.MIN:
                {
                this.state = 465;
                this.aggregation_qualified();
                }
                break;
            case DerivedEvents.INDEX:
                {
                this.state = 466;
                this.specific_instance();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 469;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext {
        let localContext = new Aggregation_qualifiedContext(this.context, this.state);
        this.enterRule(localContext, 48, DerivedEvents.RULE_aggregation_qualified);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 471;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 91 || _la === 92)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public specific_instance(): Specific_instanceContext {
        let localContext = new Specific_instanceContext(this.context, this.state);
        this.enterRule(localContext, 50, DerivedEvents.RULE_specific_instance);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 473;
            this.match(DerivedEvents.INDEX);
            this.state = 474;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 475;
            this.match(DerivedEvents.INT);
            this.state = 476;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position_error(): Instance_event_position_errorContext {
        let localContext = new Instance_event_position_errorContext(this.context, this.state);
        this.enterRule(localContext, 52, DerivedEvents.RULE_instance_event_position_error);
        try {
            this.state = 487;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 18, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 478;
                this.match(DerivedEvents.POSITION);
                this.state = 479;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 480;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 481;
                this.match(DerivedEvents.POSITION);
                this.state = 482;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 483;
                this.match(DerivedEvents.INDEX);
                this.state = 484;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 485;
                this.match(DerivedEvents.CLOSE_PAREN);
                this.state = 486;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_simple_event(): Qualified_simple_eventContext {
        let localContext = new Qualified_simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 54, DerivedEvents.RULE_qualified_simple_event);
        try {
            this.state = 507;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 489;
                this.match(DerivedEvents.QUALIFIED_CONDITION_OCCURRENCE_ALIAS);
                this.state = 490;
                this.match(DerivedEvents.PERIOD);
                this.state = 491;
                this.match(DerivedEvents.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case DerivedEvents.QUALIFIED_DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 492;
                this.match(DerivedEvents.QUALIFIED_DRUG_EXPOSURE_ALIAS);
                this.state = 493;
                this.match(DerivedEvents.PERIOD);
                this.state = 494;
                this.match(DerivedEvents.DRUG_EXPOSURE_DATE_ATTRIBUTE);
                }
                break;
            case DerivedEvents.QUALIFIED_MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 495;
                this.match(DerivedEvents.QUALIFIED_MEASUREMENT_ALIAS);
                this.state = 496;
                this.match(DerivedEvents.PERIOD);
                this.state = 497;
                this.match(DerivedEvents.MEASUREMENT_DATE_ATTRIBUTE);
                }
                break;
            case DerivedEvents.QUALIFIED_OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 498;
                this.match(DerivedEvents.QUALIFIED_OBSERVATION_ALIAS);
                this.state = 499;
                this.match(DerivedEvents.PERIOD);
                this.state = 500;
                this.match(DerivedEvents.OBSERVATION_DATE_ATTRIBUTE);
                }
                break;
            case DerivedEvents.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 501;
                this.match(DerivedEvents.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS);
                this.state = 502;
                this.match(DerivedEvents.PERIOD);
                this.state = 503;
                this.match(DerivedEvents.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case DerivedEvents.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 504;
                this.match(DerivedEvents.QUALIFIED_VISIT_OCCURRENCE_ALIAS);
                this.state = 505;
                this.match(DerivedEvents.PERIOD);
                this.state = 506;
                this.match(DerivedEvents.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_derived_event(): Qualified_derived_eventContext {
        let localContext = new Qualified_derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 56, DerivedEvents.RULE_qualified_derived_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 509;
            this.match(DerivedEvents.QUALIFIED_DERIVED_EVENT_NAME);
            this.state = 510;
            this.match(DerivedEvents.PERIOD);
            this.state = 511;
            this.match(DerivedEvents.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext {
        let localContext = new Sequence_event_constraint_errorContext(this.context, this.state);
        this.enterRule(localContext, 58, DerivedEvents.RULE_sequence_event_constraint_error);
        let _la: number;
        try {
            this.state = 525;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 20, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 513;
                this.match(DerivedEvents.TC);
                this.state = 514;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 515;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 516;
                this.match(DerivedEvents.TC);
                this.state = 517;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 518;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 111)) & ~0x1F) === 0 && ((1 << (_la - 111)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 519;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 520;
                this.match(DerivedEvents.TC);
                this.state = 521;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 522;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 111)) & ~0x1F) === 0 && ((1 << (_la - 111)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 523;
                this.match(DerivedEvents.INT);
                this.state = 524;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_error(): Derived_event_errorContext {
        let localContext = new Derived_event_errorContext(this.context, this.state);
        this.enterRule(localContext, 60, DerivedEvents.RULE_derived_event_error);
        let _la: number;
        try {
            this.state = 539;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 21, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 527;
                this.match(DerivedEvents.DERIVED_EVENT);
                this.state = 528;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 529;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 530;
                this.match(DerivedEvents.DERIVED_EVENT);
                this.state = 531;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 532;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 25)) & ~0x1F) === 0 && ((1 << (_la - 25)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 533;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 534;
                this.match(DerivedEvents.DERIVED_EVENT);
                this.state = 535;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 536;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 25)) & ~0x1F) === 0 && ((1 << (_la - 25)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 537;
                this.match(DerivedEvents.PERIOD);
                this.state = 538;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext {
        let localContext = new Derived_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 62, DerivedEvents.RULE_derived_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 541;
            this.match(DerivedEvents.MINIMUM_BETWEEN);
            this.state = 542;
            this.derived_event_int();
            this.state = 543;
            this.match(DerivedEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext {
        let localContext = new Derived_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 64, DerivedEvents.RULE_derived_uniqueness_filter_window);
        try {
            this.state = 547;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 545;
                this.derived_fixed_window_uniqueness_filter();
                }
                break;
            case DerivedEvents.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 546;
                this.derived_rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext {
        let localContext = new Derived_fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 66, DerivedEvents.RULE_derived_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 549;
            this.match(DerivedEvents.FIXED_WINDOW);
            this.state = 550;
            this.derived_event_int();
            this.state = 551;
            this.match(DerivedEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext {
        let localContext = new Derived_rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 68, DerivedEvents.RULE_derived_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 553;
            this.match(DerivedEvents.ROLLING_WINDOW);
            this.state = 554;
            this.derived_event_int();
            this.state = 555;
            this.match(DerivedEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_int(): Derived_event_intContext {
        let localContext = new Derived_event_intContext(this.context, this.state);
        this.enterRule(localContext, 70, DerivedEvents.RULE_derived_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 557;
            this.match(DerivedEvents.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event(): Simple_eventContext {
        let localContext = new Simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 72, DerivedEvents.RULE_simple_event);
        try {
            this.state = 565;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 559;
                this.condition_occurrence_event();
                }
                break;
            case DerivedEvents.DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 560;
                this.drug_exposure_event();
                }
                break;
            case DerivedEvents.MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 561;
                this.measurement_event();
                }
                break;
            case DerivedEvents.OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 562;
                this.observation_event();
                }
                break;
            case DerivedEvents.PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 563;
                this.procedure_occurrence_event();
                }
                break;
            case DerivedEvents.VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 564;
                this.visit_occurrence_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext {
        let localContext = new Condition_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 74, DerivedEvents.RULE_condition_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 567;
            localContext._event_name = this.match(DerivedEvents.CONDITION_OCCURRENCE_ALIAS);
            this.state = 568;
            this.match(DerivedEvents.EQ);
            this.state = 569;
            localContext._event_definition = this.condition_occurrence_event_definition();
            this.state = 570;
            this.match(DerivedEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event(): Drug_exposure_eventContext {
        let localContext = new Drug_exposure_eventContext(this.context, this.state);
        this.enterRule(localContext, 76, DerivedEvents.RULE_drug_exposure_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 572;
            localContext._event_name = this.match(DerivedEvents.DRUG_EXPOSURE_ALIAS);
            this.state = 573;
            this.match(DerivedEvents.EQ);
            this.state = 574;
            localContext._event_definition = this.drug_exposure_event_definition();
            this.state = 575;
            this.match(DerivedEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event(): Measurement_eventContext {
        let localContext = new Measurement_eventContext(this.context, this.state);
        this.enterRule(localContext, 78, DerivedEvents.RULE_measurement_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 577;
            localContext._event_name = this.match(DerivedEvents.MEASUREMENT_ALIAS);
            this.state = 578;
            this.match(DerivedEvents.EQ);
            this.state = 579;
            localContext._event_definition = this.measurement_event_definition();
            this.state = 580;
            this.match(DerivedEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event(): Observation_eventContext {
        let localContext = new Observation_eventContext(this.context, this.state);
        this.enterRule(localContext, 80, DerivedEvents.RULE_observation_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 582;
            localContext._event_name = this.match(DerivedEvents.OBSERVATION_ALIAS);
            this.state = 583;
            this.match(DerivedEvents.EQ);
            this.state = 584;
            localContext._event_definition = this.observation_event_definition();
            this.state = 585;
            this.match(DerivedEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext {
        let localContext = new Procedure_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 82, DerivedEvents.RULE_procedure_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 587;
            localContext._event_name = this.match(DerivedEvents.PROCEDURE_OCCURRENCE_ALIAS);
            this.state = 588;
            this.match(DerivedEvents.EQ);
            this.state = 589;
            localContext._event_definition = this.procedure_occurrence_event_definition();
            this.state = 590;
            this.match(DerivedEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext {
        let localContext = new Visit_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 84, DerivedEvents.RULE_visit_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 592;
            localContext._event_name = this.match(DerivedEvents.VISIT_OCCURRENCE_ALIAS);
            this.state = 593;
            this.match(DerivedEvents.EQ);
            this.state = 594;
            localContext._event_definition = this.visit_occurrence_event_definition();
            this.state = 595;
            this.match(DerivedEvents.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        let localContext = new Condition_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 86, DerivedEvents.RULE_condition_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 597;
            localContext._prefix = this.match(DerivedEvents.CONDITION_OCCURRENCE);
            this.state = 598;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 600;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2359808) !== 0)) {
                {
                this.state = 599;
                localContext._criteria = this.condition_occurrence_event_criteria();
                }
            }

            this.state = 602;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        let localContext = new Drug_exposure_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 88, DerivedEvents.RULE_drug_exposure_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 604;
            localContext._prefix = this.match(DerivedEvents.DRUG_EXPOSURE);
            this.state = 605;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 607;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2363904) !== 0)) {
                {
                this.state = 606;
                localContext._criteria = this.drug_exposure_event_criteria();
                }
            }

            this.state = 609;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        let localContext = new Measurement_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 90, DerivedEvents.RULE_measurement_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 611;
            localContext._prefix = this.match(DerivedEvents.MEASUREMENT);
            this.state = 612;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 614;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2363904) !== 0)) {
                {
                this.state = 613;
                localContext._criteria = this.measurement_event_criteria();
                }
            }

            this.state = 616;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        let localContext = new Observation_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 92, DerivedEvents.RULE_observation_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 618;
            localContext._prefix = this.match(DerivedEvents.OBSERVATION);
            this.state = 619;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 621;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2363904) !== 0)) {
                {
                this.state = 620;
                localContext._criteria = this.observation_event_criteria();
                }
            }

            this.state = 623;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        let localContext = new Procedure_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 94, DerivedEvents.RULE_procedure_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 625;
            localContext._prefix = this.match(DerivedEvents.PROCEDURE_OCCURRENCE);
            this.state = 626;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 628;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2363904) !== 0)) {
                {
                this.state = 627;
                localContext._criteria = this.procedure_occurrence_event_criteria();
                }
            }

            this.state = 630;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        let localContext = new Visit_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 96, DerivedEvents.RULE_visit_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 632;
            localContext._prefix = this.match(DerivedEvents.VISIT_OCCURRENCE);
            this.state = 633;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 635;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2359808) !== 0)) {
                {
                this.state = 634;
                localContext._criteria = this.visit_occurrence_event_criteria();
                }
            }

            this.state = 637;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext {
        let localContext = new Condition_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 98, DerivedEvents.RULE_condition_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 639;
            this.condition_occurrence_event_filter();
            this.state = 644;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 79) {
                {
                {
                this.state = 640;
                this.match(DerivedEvents.COMMA);
                this.state = 641;
                this.condition_occurrence_event_filter();
                }
                }
                this.state = 646;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext {
        let localContext = new Condition_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 100, DerivedEvents.RULE_condition_occurrence_event_filter);
        try {
            this.state = 651;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 31, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 647;
                this.condition_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 648;
                this.condition_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 649;
                this.condition_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 650;
                this.condition_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext {
        let localContext = new Condition_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 102, DerivedEvents.RULE_condition_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 653;
            this.match(DerivedEvents.CF);
            this.state = 654;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 657;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 32, this.context) ) {
            case 1:
                {
                this.state = 655;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 656;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            this.state = 659;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext {
        let localContext = new Condition_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 104, DerivedEvents.RULE_condition_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 661;
            this.match(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 662;
            this.match(DerivedEvents.IN);
            this.state = 663;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext {
        let localContext = new Condition_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 106, DerivedEvents.RULE_condition_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 665;
            this.match(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 666;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 80 || _la === 86)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 667;
            this.match(DerivedEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext {
        let localContext = new Condition_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 108, DerivedEvents.RULE_condition_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 669;
            this.match(DerivedEvents.UF);
            this.state = 670;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 671;
            this.condition_occurrence_uniqueness_filter();
            this.state = 672;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        let localContext = new Condition_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 110, DerivedEvents.RULE_condition_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 676;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.MINIMUM_BETWEEN:
                {
                this.state = 674;
                this.simple_uniqueness_filter();
                }
                break;
            case DerivedEvents.FIXED_WINDOW:
            case DerivedEvents.ROLLING_WINDOW:
                {
                this.state = 675;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 678;
            localContext._date_attr = this.match(DerivedEvents.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext {
        let localContext = new Condition_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 112, DerivedEvents.RULE_condition_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 680;
            this.match(DerivedEvents.RF);
            this.state = 681;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 682;
            this.condition_occurrence_related_entity_filter();
            this.state = 683;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        let localContext = new Condition_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 114, DerivedEvents.RULE_condition_occurrence_related_entity_filter);
        try {
            this.state = 687;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 685;
                this.provider_sub_filter();
                }
                break;
            case DerivedEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 686;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext {
        let localContext = new Condition_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 116, DerivedEvents.RULE_condition_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 689;
            this.match(DerivedEvents.CONDITION_OCCURRENCE);
            this.state = 692;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 35, this.context) ) {
            case 1:
                {
                this.state = 690;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 691;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext {
        let localContext = new Condition_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 118, DerivedEvents.RULE_condition_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 704;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 36, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 695;
                this.match(DerivedEvents.CONDITION_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 696;
                this.match(DerivedEvents.CONDITION_OCCURRENCE);
                this.state = 697;
                this.match(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 698;
                this.match(DerivedEvents.CONDITION_OCCURRENCE);
                this.state = 699;
                this.match(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 700;
                this.match(DerivedEvents.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 701;
                this.match(DerivedEvents.CONDITION_OCCURRENCE);
                this.state = 702;
                this.match(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 703;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext {
        let localContext = new Condition_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 120, DerivedEvents.RULE_condition_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 790;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 37, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 706;
                this.match(DerivedEvents.CF);
                this.state = 707;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 708;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 709;
                this.match(DerivedEvents.CF);
                this.state = 710;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 711;
                this.match(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 712;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 713;
                this.match(DerivedEvents.CF);
                this.state = 714;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 715;
                this.match(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 716;
                this.match(DerivedEvents.IN);
                this.state = 717;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 718;
                this.match(DerivedEvents.CF);
                this.state = 719;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 720;
                this.match(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 721;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 722;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 723;
                this.match(DerivedEvents.UF);
                this.state = 724;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 725;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 726;
                this.match(DerivedEvents.UF);
                this.state = 727;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 728;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 729;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 730;
                this.match(DerivedEvents.UF);
                this.state = 731;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 732;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 733;
                this.simple_event_int();
                this.state = 734;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 736;
                this.match(DerivedEvents.UF);
                this.state = 737;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 738;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 739;
                this.simple_event_int();
                this.state = 740;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 741;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 743;
                this.match(DerivedEvents.UF);
                this.state = 744;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 745;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 746;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 747;
                this.match(DerivedEvents.UF);
                this.state = 748;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 749;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 750;
                this.simple_event_int();
                this.state = 751;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 753;
                this.match(DerivedEvents.UF);
                this.state = 754;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 755;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 756;
                this.simple_event_int();
                this.state = 757;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 758;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 760;
                this.match(DerivedEvents.UF);
                this.state = 761;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 762;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 763;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 764;
                this.match(DerivedEvents.UF);
                this.state = 765;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 766;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 767;
                this.simple_event_int();
                this.state = 768;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 770;
                this.match(DerivedEvents.UF);
                this.state = 771;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 772;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 773;
                this.simple_event_int();
                this.state = 774;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 775;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 777;
                this.match(DerivedEvents.RF);
                this.state = 778;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 779;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 780;
                this.match(DerivedEvents.RF);
                this.state = 781;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 782;
                this.provider_error_sub_filter();
                this.state = 783;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 785;
                this.match(DerivedEvents.RF);
                this.state = 786;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 787;
                this.visit_occurrence_error_sub_filter();
                this.state = 788;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext {
        let localContext = new Drug_exposure_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 122, DerivedEvents.RULE_drug_exposure_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 792;
            this.drug_exposure_event_filter();
            this.state = 797;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 79) {
                {
                {
                this.state = 793;
                this.match(DerivedEvents.COMMA);
                this.state = 794;
                this.drug_exposure_event_filter();
                }
                }
                this.state = 799;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext {
        let localContext = new Drug_exposure_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 124, DerivedEvents.RULE_drug_exposure_event_filter);
        try {
            this.state = 805;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 39, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 800;
                this.drug_exposure_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 801;
                this.drug_exposure_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 802;
                this.drug_exposure_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 803;
                this.drug_exposure_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 804;
                this.drug_exposure_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext {
        let localContext = new Drug_exposure_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 126, DerivedEvents.RULE_drug_exposure_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 807;
            this.match(DerivedEvents.CF);
            this.state = 808;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 811;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 40, this.context) ) {
            case 1:
                {
                this.state = 809;
                this.drug_exposure_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 810;
                this.drug_exposure_concept_filter();
                }
                break;
            }
            this.state = 813;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext {
        let localContext = new Drug_exposure_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 128, DerivedEvents.RULE_drug_exposure_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 815;
            this.match(DerivedEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 816;
            this.match(DerivedEvents.IN);
            this.state = 817;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext {
        let localContext = new Drug_exposure_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 130, DerivedEvents.RULE_drug_exposure_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 819;
            this.match(DerivedEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 820;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 80 || _la === 86)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 821;
            this.match(DerivedEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext {
        let localContext = new Drug_exposure_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 132, DerivedEvents.RULE_drug_exposure_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 823;
            this.match(DerivedEvents.NF);
            this.state = 824;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 827;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.QUANTITY:
                {
                this.state = 825;
                this.drug_exposure_float_filter();
                }
                break;
            case DerivedEvents.DRUG_EXPOSURE_INT_ATTRIBUTE:
                {
                this.state = 826;
                this.drug_exposure_int_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 829;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext {
        let localContext = new Drug_exposure_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 134, DerivedEvents.RULE_drug_exposure_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 831;
            this.match(DerivedEvents.QUANTITY);
            this.state = 832;
            this.comparison_op();
            this.state = 833;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext {
        let localContext = new Drug_exposure_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 136, DerivedEvents.RULE_drug_exposure_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 835;
            this.match(DerivedEvents.DRUG_EXPOSURE_INT_ATTRIBUTE);
            this.state = 836;
            this.comparison_op();
            this.state = 837;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext {
        let localContext = new Drug_exposure_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 138, DerivedEvents.RULE_drug_exposure_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 839;
            this.match(DerivedEvents.UF);
            this.state = 840;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 841;
            this.drug_exposure_uniqueness_filter();
            this.state = 842;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        let localContext = new Drug_exposure_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 140, DerivedEvents.RULE_drug_exposure_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 846;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.MINIMUM_BETWEEN:
                {
                this.state = 844;
                this.simple_uniqueness_filter();
                }
                break;
            case DerivedEvents.FIXED_WINDOW:
            case DerivedEvents.ROLLING_WINDOW:
                {
                this.state = 845;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 848;
            this.match(DerivedEvents.DRUG_EXPOSURE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext {
        let localContext = new Drug_exposure_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 142, DerivedEvents.RULE_drug_exposure_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 850;
            this.match(DerivedEvents.RF);
            this.state = 851;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 852;
            this.drug_exposure_related_entity_filter();
            this.state = 853;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        let localContext = new Drug_exposure_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 144, DerivedEvents.RULE_drug_exposure_related_entity_filter);
        try {
            this.state = 857;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 855;
                this.provider_sub_filter();
                }
                break;
            case DerivedEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 856;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext {
        let localContext = new Drug_exposure_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 146, DerivedEvents.RULE_drug_exposure_error_filter);
        let _la: number;
        try {
            this.state = 966;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 44, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 859;
                this.match(DerivedEvents.CF);
                this.state = 860;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 861;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 862;
                this.match(DerivedEvents.CF);
                this.state = 863;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 864;
                this.match(DerivedEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 865;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 866;
                this.match(DerivedEvents.CF);
                this.state = 867;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 868;
                this.match(DerivedEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 869;
                this.match(DerivedEvents.IN);
                this.state = 870;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 871;
                this.match(DerivedEvents.CF);
                this.state = 872;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 873;
                this.match(DerivedEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 874;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 875;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 876;
                this.match(DerivedEvents.NF);
                this.state = 877;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 878;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 879;
                this.match(DerivedEvents.NF);
                this.state = 880;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 881;
                this.match(DerivedEvents.QUANTITY);
                this.state = 882;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 883;
                this.match(DerivedEvents.NF);
                this.state = 884;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 885;
                this.match(DerivedEvents.QUANTITY);
                this.state = 886;
                this.comparison_op();
                this.state = 887;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 889;
                this.match(DerivedEvents.NF);
                this.state = 890;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 891;
                this.match(DerivedEvents.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 892;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 893;
                this.match(DerivedEvents.NF);
                this.state = 894;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 895;
                this.match(DerivedEvents.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 896;
                this.comparison_op();
                this.state = 897;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 899;
                this.match(DerivedEvents.UF);
                this.state = 900;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 901;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 902;
                this.match(DerivedEvents.UF);
                this.state = 903;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 904;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 905;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 906;
                this.match(DerivedEvents.UF);
                this.state = 907;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 908;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 909;
                this.simple_event_int();
                this.state = 910;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 912;
                this.match(DerivedEvents.UF);
                this.state = 913;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 914;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 915;
                this.simple_event_int();
                this.state = 916;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 917;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 919;
                this.match(DerivedEvents.UF);
                this.state = 920;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 921;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 922;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 923;
                this.match(DerivedEvents.UF);
                this.state = 924;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 925;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 926;
                this.simple_event_int();
                this.state = 927;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 929;
                this.match(DerivedEvents.UF);
                this.state = 930;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 931;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 932;
                this.simple_event_int();
                this.state = 933;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 934;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 936;
                this.match(DerivedEvents.UF);
                this.state = 937;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 938;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 939;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 940;
                this.match(DerivedEvents.UF);
                this.state = 941;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 942;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 943;
                this.simple_event_int();
                this.state = 944;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 946;
                this.match(DerivedEvents.UF);
                this.state = 947;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 948;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 949;
                this.simple_event_int();
                this.state = 950;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 951;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 953;
                this.match(DerivedEvents.RF);
                this.state = 954;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 955;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 956;
                this.match(DerivedEvents.RF);
                this.state = 957;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 958;
                this.provider_error_sub_filter();
                this.state = 959;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 961;
                this.match(DerivedEvents.RF);
                this.state = 962;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 963;
                this.visit_occurrence_error_sub_filter();
                this.state = 964;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext {
        let localContext = new Measurement_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 148, DerivedEvents.RULE_measurement_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 968;
            this.measurement_event_filter();
            this.state = 973;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 79) {
                {
                {
                this.state = 969;
                this.match(DerivedEvents.COMMA);
                this.state = 970;
                this.measurement_event_filter();
                }
                }
                this.state = 975;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_filter(): Measurement_event_filterContext {
        let localContext = new Measurement_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 150, DerivedEvents.RULE_measurement_event_filter);
        try {
            this.state = 981;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 46, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 976;
                this.measurement_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 977;
                this.measurement_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 978;
                this.measurement_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 979;
                this.measurement_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 980;
                this.measurement_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext {
        let localContext = new Measurement_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 152, DerivedEvents.RULE_measurement_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 983;
            this.match(DerivedEvents.CF);
            this.state = 984;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 987;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 47, this.context) ) {
            case 1:
                {
                this.state = 985;
                this.measurement_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 986;
                this.measurement_concept_filter();
                }
                break;
            }
            this.state = 989;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext {
        let localContext = new Measurement_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 154, DerivedEvents.RULE_measurement_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 991;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 159 || _la === 165)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 992;
            this.match(DerivedEvents.IN);
            this.state = 993;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filter(): Measurement_concept_filterContext {
        let localContext = new Measurement_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 156, DerivedEvents.RULE_measurement_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 995;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 159 || _la === 165)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 996;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 80 || _la === 86)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 997;
            this.match(DerivedEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext {
        let localContext = new Measurement_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 158, DerivedEvents.RULE_measurement_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 999;
            this.match(DerivedEvents.NF);
            this.state = 1000;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1001;
            this.measurement_float_filter();
            this.state = 1002;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        let localContext = new Measurement_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 160, DerivedEvents.RULE_measurement_float_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1004;
            _la = this.tokenStream.LA(1);
            if(!(_la === 153 || _la === 155)) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1005;
            this.comparison_op();
            this.state = 1006;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext {
        let localContext = new Measurement_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 162, DerivedEvents.RULE_measurement_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1008;
            this.match(DerivedEvents.UF);
            this.state = 1009;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1010;
            this.measurement_uniqueness_filter();
            this.state = 1011;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        let localContext = new Measurement_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 164, DerivedEvents.RULE_measurement_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1015;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.MINIMUM_BETWEEN:
                {
                this.state = 1013;
                this.simple_uniqueness_filter();
                }
                break;
            case DerivedEvents.FIXED_WINDOW:
            case DerivedEvents.ROLLING_WINDOW:
                {
                this.state = 1014;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1017;
            this.match(DerivedEvents.MEASUREMENT_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext {
        let localContext = new Measurement_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 166, DerivedEvents.RULE_measurement_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1019;
            this.match(DerivedEvents.RF);
            this.state = 1020;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1021;
            this.measurement_related_entity_filter();
            this.state = 1022;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        let localContext = new Measurement_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 168, DerivedEvents.RULE_measurement_related_entity_filter);
        try {
            this.state = 1026;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1024;
                this.provider_sub_filter();
                }
                break;
            case DerivedEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1025;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_error_filter(): Measurement_error_filterContext {
        let localContext = new Measurement_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 170, DerivedEvents.RULE_measurement_error_filter);
        let _la: number;
        try {
            this.state = 1139;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 50, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1028;
                this.match(DerivedEvents.CF);
                this.state = 1029;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1030;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1031;
                this.match(DerivedEvents.CF);
                this.state = 1032;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1033;
                this.match(DerivedEvents.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1034;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1035;
                this.match(DerivedEvents.CF);
                this.state = 1036;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1037;
                this.match(DerivedEvents.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1038;
                this.match(DerivedEvents.IN);
                this.state = 1039;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1040;
                this.match(DerivedEvents.CF);
                this.state = 1041;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1042;
                this.match(DerivedEvents.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1043;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1044;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1045;
                this.match(DerivedEvents.CF);
                this.state = 1046;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1047;
                this.match(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1048;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1049;
                this.match(DerivedEvents.CF);
                this.state = 1050;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1051;
                this.match(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1052;
                this.match(DerivedEvents.IN);
                this.state = 1053;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1054;
                this.match(DerivedEvents.CF);
                this.state = 1055;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1056;
                this.match(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1057;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1058;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1059;
                this.match(DerivedEvents.NF);
                this.state = 1060;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1061;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1062;
                this.match(DerivedEvents.NF);
                this.state = 1063;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1064;
                _la = this.tokenStream.LA(1);
                if(!(_la === 153 || _la === 155)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1065;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1066;
                this.match(DerivedEvents.NF);
                this.state = 1067;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1068;
                _la = this.tokenStream.LA(1);
                if(!(_la === 153 || _la === 155)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1069;
                this.comparison_op();
                this.state = 1070;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1072;
                this.match(DerivedEvents.UF);
                this.state = 1073;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1074;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1075;
                this.match(DerivedEvents.UF);
                this.state = 1076;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1077;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1078;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1079;
                this.match(DerivedEvents.UF);
                this.state = 1080;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1081;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1082;
                this.simple_event_int();
                this.state = 1083;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1085;
                this.match(DerivedEvents.UF);
                this.state = 1086;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1087;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1088;
                this.simple_event_int();
                this.state = 1089;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1090;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1092;
                this.match(DerivedEvents.UF);
                this.state = 1093;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1094;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1095;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1096;
                this.match(DerivedEvents.UF);
                this.state = 1097;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1098;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1099;
                this.simple_event_int();
                this.state = 1100;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1102;
                this.match(DerivedEvents.UF);
                this.state = 1103;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1104;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1105;
                this.simple_event_int();
                this.state = 1106;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1107;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1109;
                this.match(DerivedEvents.UF);
                this.state = 1110;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1111;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1112;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1113;
                this.match(DerivedEvents.UF);
                this.state = 1114;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1115;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1116;
                this.simple_event_int();
                this.state = 1117;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1119;
                this.match(DerivedEvents.UF);
                this.state = 1120;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1121;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1122;
                this.simple_event_int();
                this.state = 1123;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1124;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1126;
                this.match(DerivedEvents.RF);
                this.state = 1127;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1128;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1129;
                this.match(DerivedEvents.RF);
                this.state = 1130;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1131;
                this.provider_error_sub_filter();
                this.state = 1132;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1134;
                this.match(DerivedEvents.RF);
                this.state = 1135;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1136;
                this.visit_occurrence_error_sub_filter();
                this.state = 1137;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_criteria(): Observation_event_criteriaContext {
        let localContext = new Observation_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 172, DerivedEvents.RULE_observation_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1141;
            this.observation_event_filter();
            this.state = 1146;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 79) {
                {
                {
                this.state = 1142;
                this.match(DerivedEvents.COMMA);
                this.state = 1143;
                this.observation_event_filter();
                }
                }
                this.state = 1148;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_filter(): Observation_event_filterContext {
        let localContext = new Observation_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 174, DerivedEvents.RULE_observation_event_filter);
        try {
            this.state = 1154;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 52, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1149;
                this.observation_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1150;
                this.observation_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1151;
                this.observation_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1152;
                this.observation_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1153;
                this.observation_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filters(): Observation_concept_filtersContext {
        let localContext = new Observation_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 176, DerivedEvents.RULE_observation_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1156;
            this.match(DerivedEvents.CF);
            this.state = 1157;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1160;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 53, this.context) ) {
            case 1:
                {
                this.state = 1158;
                this.observation_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1159;
                this.observation_concept_filter();
                }
                break;
            }
            this.state = 1162;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext {
        let localContext = new Observation_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 178, DerivedEvents.RULE_observation_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1164;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 160 || _la === 165)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1165;
            this.match(DerivedEvents.IN);
            this.state = 1166;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filter(): Observation_concept_filterContext {
        let localContext = new Observation_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 180, DerivedEvents.RULE_observation_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1168;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 160 || _la === 165)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1169;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 80 || _la === 86)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1170;
            this.match(DerivedEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext {
        let localContext = new Observation_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 182, DerivedEvents.RULE_observation_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1172;
            this.match(DerivedEvents.NF);
            this.state = 1173;
            this.match(DerivedEvents.OPEN_PAREN);
            {
            this.state = 1174;
            this.observation_float_filter();
            }
            this.state = 1175;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_float_filter(): Observation_float_filterContext {
        let localContext = new Observation_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 184, DerivedEvents.RULE_observation_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1177;
            this.match(DerivedEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
            this.state = 1178;
            this.comparison_op();
            this.state = 1179;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext {
        let localContext = new Observation_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 186, DerivedEvents.RULE_observation_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1181;
            this.match(DerivedEvents.UF);
            this.state = 1182;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1183;
            this.observation_uniqueness_filter();
            this.state = 1184;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        let localContext = new Observation_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 188, DerivedEvents.RULE_observation_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1188;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.MINIMUM_BETWEEN:
                {
                this.state = 1186;
                this.simple_uniqueness_filter();
                }
                break;
            case DerivedEvents.FIXED_WINDOW:
            case DerivedEvents.ROLLING_WINDOW:
                {
                this.state = 1187;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1190;
            this.match(DerivedEvents.OBSERVATION_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext {
        let localContext = new Observation_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 190, DerivedEvents.RULE_observation_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1192;
            this.match(DerivedEvents.RF);
            this.state = 1193;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1194;
            this.observation_related_entity_filter();
            this.state = 1195;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        let localContext = new Observation_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 192, DerivedEvents.RULE_observation_related_entity_filter);
        try {
            this.state = 1199;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1197;
                this.provider_sub_filter();
                }
                break;
            case DerivedEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1198;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_error_filter(): Observation_error_filterContext {
        let localContext = new Observation_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 194, DerivedEvents.RULE_observation_error_filter);
        let _la: number;
        try {
            this.state = 1312;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 56, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1201;
                this.match(DerivedEvents.CF);
                this.state = 1202;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1203;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1204;
                this.match(DerivedEvents.CF);
                this.state = 1205;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1206;
                this.match(DerivedEvents.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1207;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1208;
                this.match(DerivedEvents.CF);
                this.state = 1209;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1210;
                this.match(DerivedEvents.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1211;
                this.match(DerivedEvents.IN);
                this.state = 1212;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1213;
                this.match(DerivedEvents.CF);
                this.state = 1214;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1215;
                this.match(DerivedEvents.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1216;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1217;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1218;
                this.match(DerivedEvents.CF);
                this.state = 1219;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1220;
                this.match(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1221;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1222;
                this.match(DerivedEvents.CF);
                this.state = 1223;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1224;
                this.match(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1225;
                this.match(DerivedEvents.IN);
                this.state = 1226;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1227;
                this.match(DerivedEvents.CF);
                this.state = 1228;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1229;
                this.match(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1230;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1231;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1232;
                this.match(DerivedEvents.NF);
                this.state = 1233;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1234;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1235;
                this.match(DerivedEvents.NF);
                this.state = 1236;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1237;
                this.match(DerivedEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1238;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1239;
                this.match(DerivedEvents.NF);
                this.state = 1240;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1241;
                this.match(DerivedEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1242;
                this.comparison_op();
                this.state = 1243;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1245;
                this.match(DerivedEvents.UF);
                this.state = 1246;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1247;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1248;
                this.match(DerivedEvents.UF);
                this.state = 1249;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1250;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1251;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1252;
                this.match(DerivedEvents.UF);
                this.state = 1253;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1254;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1255;
                this.simple_event_int();
                this.state = 1256;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1258;
                this.match(DerivedEvents.UF);
                this.state = 1259;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1260;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1261;
                this.simple_event_int();
                this.state = 1262;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1263;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1265;
                this.match(DerivedEvents.UF);
                this.state = 1266;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1267;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1268;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1269;
                this.match(DerivedEvents.UF);
                this.state = 1270;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1271;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1272;
                this.simple_event_int();
                this.state = 1273;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1275;
                this.match(DerivedEvents.UF);
                this.state = 1276;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1277;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1278;
                this.simple_event_int();
                this.state = 1279;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1280;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1282;
                this.match(DerivedEvents.UF);
                this.state = 1283;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1284;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1285;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1286;
                this.match(DerivedEvents.UF);
                this.state = 1287;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1288;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1289;
                this.simple_event_int();
                this.state = 1290;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1292;
                this.match(DerivedEvents.UF);
                this.state = 1293;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1294;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1295;
                this.simple_event_int();
                this.state = 1296;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1297;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1299;
                this.match(DerivedEvents.RF);
                this.state = 1300;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1301;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1302;
                this.match(DerivedEvents.RF);
                this.state = 1303;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1304;
                this.provider_error_sub_filter();
                this.state = 1305;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1307;
                this.match(DerivedEvents.RF);
                this.state = 1308;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1309;
                this.visit_occurrence_error_sub_filter();
                this.state = 1310;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext {
        let localContext = new Procedure_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 196, DerivedEvents.RULE_procedure_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1314;
            this.procedure_occurrence_event_filter();
            this.state = 1319;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 79) {
                {
                {
                this.state = 1315;
                this.match(DerivedEvents.COMMA);
                this.state = 1316;
                this.procedure_occurrence_event_filter();
                }
                }
                this.state = 1321;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext {
        let localContext = new Procedure_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 198, DerivedEvents.RULE_procedure_occurrence_event_filter);
        try {
            this.state = 1327;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 58, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1322;
                this.procedure_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1323;
                this.procedure_occurrence_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1324;
                this.procedure_occurrence_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1325;
                this.procedure_occurrence_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1326;
                this.procedure_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext {
        let localContext = new Procedure_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 200, DerivedEvents.RULE_procedure_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1329;
            this.match(DerivedEvents.CF);
            this.state = 1330;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1333;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 59, this.context) ) {
            case 1:
                {
                this.state = 1331;
                this.procedure_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1332;
                this.procedure_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1335;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext {
        let localContext = new Procedure_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 202, DerivedEvents.RULE_procedure_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1337;
            this.match(DerivedEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1338;
            this.match(DerivedEvents.IN);
            this.state = 1339;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext {
        let localContext = new Procedure_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 204, DerivedEvents.RULE_procedure_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1341;
            this.match(DerivedEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1342;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 80 || _la === 86)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1343;
            this.match(DerivedEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext {
        let localContext = new Procedure_occurrence_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 206, DerivedEvents.RULE_procedure_occurrence_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1345;
            this.match(DerivedEvents.NF);
            this.state = 1346;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1347;
            this.procedure_occurrence_int_filter();
            this.state = 1348;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        let localContext = new Procedure_occurrence_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 208, DerivedEvents.RULE_procedure_occurrence_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1350;
            this.match(DerivedEvents.QUANTITY);
            this.state = 1351;
            this.comparison_op();
            this.state = 1352;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext {
        let localContext = new Procedure_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 210, DerivedEvents.RULE_procedure_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1354;
            this.match(DerivedEvents.UF);
            this.state = 1355;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1356;
            this.procedure_occurrence_uniqueness_filter();
            this.state = 1357;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        let localContext = new Procedure_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 212, DerivedEvents.RULE_procedure_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1361;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.MINIMUM_BETWEEN:
                {
                this.state = 1359;
                this.simple_uniqueness_filter();
                }
                break;
            case DerivedEvents.FIXED_WINDOW:
            case DerivedEvents.ROLLING_WINDOW:
                {
                this.state = 1360;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1363;
            this.match(DerivedEvents.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext {
        let localContext = new Procedure_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 214, DerivedEvents.RULE_procedure_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1365;
            this.match(DerivedEvents.RF);
            this.state = 1366;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1367;
            this.procedure_occurrence_related_entity_filter();
            this.state = 1368;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        let localContext = new Procedure_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 216, DerivedEvents.RULE_procedure_occurrence_related_entity_filter);
        try {
            this.state = 1372;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1370;
                this.provider_sub_filter();
                }
                break;
            case DerivedEvents.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1371;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext {
        let localContext = new Procedure_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 218, DerivedEvents.RULE_procedure_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1471;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 62, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1374;
                this.match(DerivedEvents.CF);
                this.state = 1375;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1376;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1377;
                this.match(DerivedEvents.CF);
                this.state = 1378;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1379;
                this.match(DerivedEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1380;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1381;
                this.match(DerivedEvents.CF);
                this.state = 1382;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1383;
                this.match(DerivedEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1384;
                this.match(DerivedEvents.IN);
                this.state = 1385;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1386;
                this.match(DerivedEvents.CF);
                this.state = 1387;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1388;
                this.match(DerivedEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1389;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1390;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1391;
                this.match(DerivedEvents.NF);
                this.state = 1392;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1393;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1394;
                this.match(DerivedEvents.NF);
                this.state = 1395;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1396;
                this.match(DerivedEvents.QUANTITY);
                this.state = 1397;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1398;
                this.match(DerivedEvents.NF);
                this.state = 1399;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1400;
                this.match(DerivedEvents.QUANTITY);
                this.state = 1401;
                this.comparison_op();
                this.state = 1402;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1404;
                this.match(DerivedEvents.UF);
                this.state = 1405;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1406;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1407;
                this.match(DerivedEvents.UF);
                this.state = 1408;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1409;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1410;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1411;
                this.match(DerivedEvents.UF);
                this.state = 1412;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1413;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1414;
                this.simple_event_int();
                this.state = 1415;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1417;
                this.match(DerivedEvents.UF);
                this.state = 1418;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1419;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1420;
                this.simple_event_int();
                this.state = 1421;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1422;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1424;
                this.match(DerivedEvents.UF);
                this.state = 1425;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1426;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1427;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1428;
                this.match(DerivedEvents.UF);
                this.state = 1429;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1430;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1431;
                this.simple_event_int();
                this.state = 1432;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1434;
                this.match(DerivedEvents.UF);
                this.state = 1435;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1436;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1437;
                this.simple_event_int();
                this.state = 1438;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1439;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1441;
                this.match(DerivedEvents.UF);
                this.state = 1442;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1443;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1444;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1445;
                this.match(DerivedEvents.UF);
                this.state = 1446;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1447;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1448;
                this.simple_event_int();
                this.state = 1449;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1451;
                this.match(DerivedEvents.UF);
                this.state = 1452;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1453;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1454;
                this.simple_event_int();
                this.state = 1455;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1456;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1458;
                this.match(DerivedEvents.RF);
                this.state = 1459;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1460;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1461;
                this.match(DerivedEvents.RF);
                this.state = 1462;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1463;
                this.provider_error_sub_filter();
                this.state = 1464;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1466;
                this.match(DerivedEvents.RF);
                this.state = 1467;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1468;
                this.visit_occurrence_error_sub_filter();
                this.state = 1469;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filters(): Provider_concept_filtersContext {
        let localContext = new Provider_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 220, DerivedEvents.RULE_provider_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1473;
            this.match(DerivedEvents.CF);
            this.state = 1474;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1477;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 63, this.context) ) {
            case 1:
                {
                this.state = 1475;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1476;
                this.provider_concept_filter();
                }
                break;
            }
            this.state = 1479;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext {
        let localContext = new Provider_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 222, DerivedEvents.RULE_provider_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1481;
            this.match(DerivedEvents.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1482;
            this.match(DerivedEvents.IN);
            this.state = 1483;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filter(): Provider_concept_filterContext {
        let localContext = new Provider_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 224, DerivedEvents.RULE_provider_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1485;
            this.match(DerivedEvents.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1486;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 80 || _la === 86)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1487;
            this.match(DerivedEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_sub_filter(): Provider_sub_filterContext {
        let localContext = new Provider_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 226, DerivedEvents.RULE_provider_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1489;
            this.match(DerivedEvents.PROVIDER);
            this.state = 1492;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 64, this.context) ) {
            case 1:
                {
                this.state = 1490;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1491;
                this.provider_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext {
        let localContext = new Provider_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 228, DerivedEvents.RULE_provider_error_sub_filter);
        let _la: number;
        try {
            this.state = 1504;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 65, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1495;
                this.match(DerivedEvents.PROVIDER);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1496;
                this.match(DerivedEvents.PROVIDER);
                this.state = 1497;
                this.match(DerivedEvents.PROVIDER_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1498;
                this.match(DerivedEvents.PROVIDER);
                this.state = 1499;
                this.match(DerivedEvents.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1500;
                this.match(DerivedEvents.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1501;
                this.match(DerivedEvents.PROVIDER);
                this.state = 1502;
                this.match(DerivedEvents.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1503;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext {
        let localContext = new Visit_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 230, DerivedEvents.RULE_visit_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1506;
            this.visit_occurrence_event_filter();
            this.state = 1511;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 79) {
                {
                {
                this.state = 1507;
                this.match(DerivedEvents.COMMA);
                this.state = 1508;
                this.visit_occurrence_event_filter();
                }
                }
                this.state = 1513;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext {
        let localContext = new Visit_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 232, DerivedEvents.RULE_visit_occurrence_event_filter);
        try {
            this.state = 1518;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 67, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1514;
                this.visit_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1515;
                this.visit_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1516;
                this.visit_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1517;
                this.visit_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext {
        let localContext = new Visit_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 234, DerivedEvents.RULE_visit_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1520;
            this.match(DerivedEvents.CF);
            this.state = 1521;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1524;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 68, this.context) ) {
            case 1:
                {
                this.state = 1522;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1523;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1526;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext {
        let localContext = new Visit_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 236, DerivedEvents.RULE_visit_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1528;
            this.match(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1529;
            this.match(DerivedEvents.IN);
            this.state = 1530;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext {
        let localContext = new Visit_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 238, DerivedEvents.RULE_visit_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1532;
            this.match(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1533;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 80 || _la === 86)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1534;
            this.match(DerivedEvents.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext {
        let localContext = new Visit_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 240, DerivedEvents.RULE_visit_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1536;
            this.match(DerivedEvents.UF);
            this.state = 1537;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1538;
            this.visit_occurrence_uniqueness_filter();
            this.state = 1539;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        let localContext = new Visit_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 242, DerivedEvents.RULE_visit_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1543;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.MINIMUM_BETWEEN:
                {
                this.state = 1541;
                this.simple_uniqueness_filter();
                }
                break;
            case DerivedEvents.FIXED_WINDOW:
            case DerivedEvents.ROLLING_WINDOW:
                {
                this.state = 1542;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1545;
            this.match(DerivedEvents.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext {
        let localContext = new Visit_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 244, DerivedEvents.RULE_visit_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1547;
            this.match(DerivedEvents.RF);
            this.state = 1548;
            this.match(DerivedEvents.OPEN_PAREN);
            this.state = 1549;
            this.visit_occurrence_related_entity_filter();
            this.state = 1550;
            this.match(DerivedEvents.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        let localContext = new Visit_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 246, DerivedEvents.RULE_visit_occurrence_related_entity_filter);
        try {
            this.state = 1554;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1552;
                this.provider_sub_filter();
                }
                break;
            case DerivedEvents.CONDITION_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1553;
                this.condition_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext {
        let localContext = new Visit_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 248, DerivedEvents.RULE_visit_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1556;
            this.match(DerivedEvents.VISIT_OCCURRENCE);
            this.state = 1559;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 71, this.context) ) {
            case 1:
                {
                this.state = 1557;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1558;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext {
        let localContext = new Visit_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 250, DerivedEvents.RULE_visit_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 1571;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 72, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1562;
                this.match(DerivedEvents.VISIT_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1563;
                this.match(DerivedEvents.VISIT_OCCURRENCE);
                this.state = 1564;
                this.match(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1565;
                this.match(DerivedEvents.VISIT_OCCURRENCE);
                this.state = 1566;
                this.match(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1567;
                this.match(DerivedEvents.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1568;
                this.match(DerivedEvents.VISIT_OCCURRENCE);
                this.state = 1569;
                this.match(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1570;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext {
        let localContext = new Visit_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 252, DerivedEvents.RULE_visit_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1657;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 73, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1573;
                this.match(DerivedEvents.CF);
                this.state = 1574;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1575;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1576;
                this.match(DerivedEvents.CF);
                this.state = 1577;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1578;
                this.match(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1579;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1580;
                this.match(DerivedEvents.CF);
                this.state = 1581;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1582;
                this.match(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1583;
                this.match(DerivedEvents.IN);
                this.state = 1584;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1585;
                this.match(DerivedEvents.CF);
                this.state = 1586;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1587;
                this.match(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1588;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 80 || _la === 86)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1589;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1590;
                this.match(DerivedEvents.UF);
                this.state = 1591;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1592;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1593;
                this.match(DerivedEvents.UF);
                this.state = 1594;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1595;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1596;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1597;
                this.match(DerivedEvents.UF);
                this.state = 1598;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1599;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1600;
                this.simple_event_int();
                this.state = 1601;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1603;
                this.match(DerivedEvents.UF);
                this.state = 1604;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1605;
                this.match(DerivedEvents.MINIMUM_BETWEEN);
                this.state = 1606;
                this.simple_event_int();
                this.state = 1607;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1608;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1610;
                this.match(DerivedEvents.UF);
                this.state = 1611;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1612;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1613;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1614;
                this.match(DerivedEvents.UF);
                this.state = 1615;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1616;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1617;
                this.simple_event_int();
                this.state = 1618;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1620;
                this.match(DerivedEvents.UF);
                this.state = 1621;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1622;
                this.match(DerivedEvents.FIXED_WINDOW);
                this.state = 1623;
                this.simple_event_int();
                this.state = 1624;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1625;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1627;
                this.match(DerivedEvents.UF);
                this.state = 1628;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1629;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1630;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1631;
                this.match(DerivedEvents.UF);
                this.state = 1632;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1633;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1634;
                this.simple_event_int();
                this.state = 1635;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1637;
                this.match(DerivedEvents.UF);
                this.state = 1638;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1639;
                this.match(DerivedEvents.ROLLING_WINDOW);
                this.state = 1640;
                this.simple_event_int();
                this.state = 1641;
                this.match(DerivedEvents.TIME_UNIT);
                this.state = 1642;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1644;
                this.match(DerivedEvents.RF);
                this.state = 1645;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1646;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1647;
                this.match(DerivedEvents.RF);
                this.state = 1648;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1649;
                this.provider_error_sub_filter();
                this.state = 1650;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1652;
                this.match(DerivedEvents.RF);
                this.state = 1653;
                this.match(DerivedEvents.OPEN_PAREN);
                this.state = 1654;
                this.condition_occurrence_error_sub_filter();
                this.state = 1655;
                this.match(DerivedEvents.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public comparison_op(): Comparison_opContext {
        let localContext = new Comparison_opContext(this.context, this.state);
        this.enterRule(localContext, 254, DerivedEvents.RULE_comparison_op);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1659;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 80)) & ~0x1F) === 0 && ((1 << (_la - 80)) & 1985) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext {
        let localContext = new Simple_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 256, DerivedEvents.RULE_simple_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1661;
            this.match(DerivedEvents.MINIMUM_BETWEEN);
            this.state = 1662;
            this.simple_event_int();
            this.state = 1663;
            this.match(DerivedEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext {
        let localContext = new Simple_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 258, DerivedEvents.RULE_simple_uniqueness_filter_window);
        try {
            this.state = 1667;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case DerivedEvents.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1665;
                this.fixed_window_uniqueness_filter();
                }
                break;
            case DerivedEvents.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1666;
                this.rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext {
        let localContext = new Fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 260, DerivedEvents.RULE_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1669;
            this.match(DerivedEvents.FIXED_WINDOW);
            this.state = 1670;
            this.simple_event_int();
            this.state = 1671;
            this.match(DerivedEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext {
        let localContext = new Rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 262, DerivedEvents.RULE_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1673;
            this.match(DerivedEvents.ROLLING_WINDOW);
            this.state = 1674;
            this.simple_event_int();
            this.state = 1675;
            this.match(DerivedEvents.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_float(): Simple_event_floatContext {
        let localContext = new Simple_event_floatContext(this.context, this.state);
        this.enterRule(localContext, 264, DerivedEvents.RULE_simple_event_float);
        let _la: number;
        try {
            this.state = 1685;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 77, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1677;
                this.simple_event_int();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1679;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 71) {
                    {
                    this.state = 1678;
                    this.match(DerivedEvents.INT);
                    }
                }

                this.state = 1681;
                this.match(DerivedEvents.PERIOD);
                this.state = 1683;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 71) {
                    {
                    this.state = 1682;
                    this.match(DerivedEvents.INT);
                    }
                }

                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_int(): Simple_event_intContext {
        let localContext = new Simple_event_intContext(this.context, this.state);
        this.enterRule(localContext, 266, DerivedEvents.RULE_simple_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1687;
            this.match(DerivedEvents.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        let localContext = new Concept_group_selectionContext(this.context, this.state);
        this.enterRule(localContext, 268, DerivedEvents.RULE_concept_group_selection);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1689;
            this.match(DerivedEvents.CONCEPT_GROUP);
            this.state = 1694;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 79) {
                {
                {
                this.state = 1690;
                this.match(DerivedEvents.COMMA);
                this.state = 1691;
                this.match(DerivedEvents.CONCEPT_GROUP);
                }
                }
                this.state = 1696;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }

    public static readonly _serializedATN: number[] = [
        4,1,177,1698,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,
        7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,13,7,
        13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,
        20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,
        26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,
        33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,
        39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,
        46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,2,52,7,
        52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,7,56,2,57,7,57,2,58,7,58,2,
        59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,63,2,64,7,64,2,65,7,
        65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,2,71,7,71,2,
        72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,2,78,7,
        78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,7,84,2,
        85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,2,91,7,
        91,2,92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,7,97,2,
        98,7,98,2,99,7,99,2,100,7,100,2,101,7,101,2,102,7,102,2,103,7,103,
        2,104,7,104,2,105,7,105,2,106,7,106,2,107,7,107,2,108,7,108,2,109,
        7,109,2,110,7,110,2,111,7,111,2,112,7,112,2,113,7,113,2,114,7,114,
        2,115,7,115,2,116,7,116,2,117,7,117,2,118,7,118,2,119,7,119,2,120,
        7,120,2,121,7,121,2,122,7,122,2,123,7,123,2,124,7,124,2,125,7,125,
        2,126,7,126,2,127,7,127,2,128,7,128,2,129,7,129,2,130,7,130,2,131,
        7,131,2,132,7,132,2,133,7,133,2,134,7,134,1,0,1,0,1,0,3,0,274,8,
        0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,283,8,1,1,1,1,1,1,1,1,2,1,2,1,
        2,4,2,291,8,2,11,2,12,2,292,1,3,1,3,3,3,297,8,3,1,4,1,4,3,4,301,
        8,4,1,5,1,5,1,5,1,5,3,5,307,8,5,1,5,1,5,1,6,1,6,1,7,1,7,1,7,1,7,
        1,7,1,8,1,8,3,8,320,8,8,1,8,1,8,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,
        1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,
        1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,
        1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,3,9,378,
        8,9,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,11,1,11,1,11,5,11,
        391,8,11,10,11,12,11,394,9,11,1,12,1,12,1,12,1,12,3,12,400,8,12,
        1,13,1,13,3,13,404,8,13,1,14,1,14,1,14,1,14,1,14,1,15,1,15,1,15,
        1,15,1,16,1,16,1,16,1,16,3,16,419,8,16,1,16,1,16,1,17,1,17,3,17,
        425,8,17,1,17,1,17,1,17,1,18,1,18,3,18,432,8,18,1,19,1,19,1,19,1,
        19,1,19,1,19,1,19,1,19,1,20,1,20,1,20,4,20,445,8,20,11,20,12,20,
        446,1,21,1,21,1,21,1,21,1,21,3,21,454,8,21,1,22,1,22,1,22,1,22,3,
        22,460,8,22,1,22,1,22,1,23,1,23,1,23,1,23,3,23,468,8,23,1,23,1,23,
        1,24,1,24,1,25,1,25,1,25,1,25,1,25,1,26,1,26,1,26,1,26,1,26,1,26,
        1,26,1,26,1,26,3,26,488,8,26,1,27,1,27,1,27,1,27,1,27,1,27,1,27,
        1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,3,27,508,
        8,27,1,28,1,28,1,28,1,28,1,29,1,29,1,29,1,29,1,29,1,29,1,29,1,29,
        1,29,1,29,1,29,1,29,3,29,526,8,29,1,30,1,30,1,30,1,30,1,30,1,30,
        1,30,1,30,1,30,1,30,1,30,1,30,3,30,540,8,30,1,31,1,31,1,31,1,31,
        1,32,1,32,3,32,548,8,32,1,33,1,33,1,33,1,33,1,34,1,34,1,34,1,34,
        1,35,1,35,1,36,1,36,1,36,1,36,1,36,1,36,3,36,566,8,36,1,37,1,37,
        1,37,1,37,1,37,1,38,1,38,1,38,1,38,1,38,1,39,1,39,1,39,1,39,1,39,
        1,40,1,40,1,40,1,40,1,40,1,41,1,41,1,41,1,41,1,41,1,42,1,42,1,42,
        1,42,1,42,1,43,1,43,1,43,3,43,601,8,43,1,43,1,43,1,44,1,44,1,44,
        3,44,608,8,44,1,44,1,44,1,45,1,45,1,45,3,45,615,8,45,1,45,1,45,1,
        46,1,46,1,46,3,46,622,8,46,1,46,1,46,1,47,1,47,1,47,3,47,629,8,47,
        1,47,1,47,1,48,1,48,1,48,3,48,636,8,48,1,48,1,48,1,49,1,49,1,49,
        5,49,643,8,49,10,49,12,49,646,9,49,1,50,1,50,1,50,1,50,3,50,652,
        8,50,1,51,1,51,1,51,1,51,3,51,658,8,51,1,51,1,51,1,52,1,52,1,52,
        1,52,1,53,1,53,1,53,1,53,1,54,1,54,1,54,1,54,1,54,1,55,1,55,3,55,
        677,8,55,1,55,1,55,1,56,1,56,1,56,1,56,1,56,1,57,1,57,3,57,688,8,
        57,1,58,1,58,1,58,3,58,693,8,58,1,59,1,59,1,59,1,59,1,59,1,59,1,
        59,1,59,1,59,1,59,3,59,705,8,59,1,60,1,60,1,60,1,60,1,60,1,60,1,
        60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,
        60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,
        60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,
        60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,
        60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,
        60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,1,60,3,
        60,791,8,60,1,61,1,61,1,61,5,61,796,8,61,10,61,12,61,799,9,61,1,
        62,1,62,1,62,1,62,1,62,3,62,806,8,62,1,63,1,63,1,63,1,63,3,63,812,
        8,63,1,63,1,63,1,64,1,64,1,64,1,64,1,65,1,65,1,65,1,65,1,66,1,66,
        1,66,1,66,3,66,828,8,66,1,66,1,66,1,67,1,67,1,67,1,67,1,68,1,68,
        1,68,1,68,1,69,1,69,1,69,1,69,1,69,1,70,1,70,3,70,847,8,70,1,70,
        1,70,1,71,1,71,1,71,1,71,1,71,1,72,1,72,3,72,858,8,72,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,
        1,73,3,73,967,8,73,1,74,1,74,1,74,5,74,972,8,74,10,74,12,74,975,
        9,74,1,75,1,75,1,75,1,75,1,75,3,75,982,8,75,1,76,1,76,1,76,1,76,
        3,76,988,8,76,1,76,1,76,1,77,1,77,1,77,1,77,1,78,1,78,1,78,1,78,
        1,79,1,79,1,79,1,79,1,79,1,80,1,80,1,80,1,80,1,81,1,81,1,81,1,81,
        1,81,1,82,1,82,3,82,1016,8,82,1,82,1,82,1,83,1,83,1,83,1,83,1,83,
        1,84,1,84,3,84,1027,8,84,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,3,85,
        1140,8,85,1,86,1,86,1,86,5,86,1145,8,86,10,86,12,86,1148,9,86,1,
        87,1,87,1,87,1,87,1,87,3,87,1155,8,87,1,88,1,88,1,88,1,88,3,88,1161,
        8,88,1,88,1,88,1,89,1,89,1,89,1,89,1,90,1,90,1,90,1,90,1,91,1,91,
        1,91,1,91,1,91,1,92,1,92,1,92,1,92,1,93,1,93,1,93,1,93,1,93,1,94,
        1,94,3,94,1189,8,94,1,94,1,94,1,95,1,95,1,95,1,95,1,95,1,96,1,96,
        3,96,1200,8,96,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,
        1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,
        1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,
        1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,
        1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,
        1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,
        1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,
        1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,
        1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,1,97,3,97,1313,8,97,
        1,98,1,98,1,98,5,98,1318,8,98,10,98,12,98,1321,9,98,1,99,1,99,1,
        99,1,99,1,99,3,99,1328,8,99,1,100,1,100,1,100,1,100,3,100,1334,8,
        100,1,100,1,100,1,101,1,101,1,101,1,101,1,102,1,102,1,102,1,102,
        1,103,1,103,1,103,1,103,1,103,1,104,1,104,1,104,1,104,1,105,1,105,
        1,105,1,105,1,105,1,106,1,106,3,106,1362,8,106,1,106,1,106,1,107,
        1,107,1,107,1,107,1,107,1,108,1,108,3,108,1373,8,108,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,3,109,1472,8,109,1,110,
        1,110,1,110,1,110,3,110,1478,8,110,1,110,1,110,1,111,1,111,1,111,
        1,111,1,112,1,112,1,112,1,112,1,113,1,113,1,113,3,113,1493,8,113,
        1,114,1,114,1,114,1,114,1,114,1,114,1,114,1,114,1,114,1,114,3,114,
        1505,8,114,1,115,1,115,1,115,5,115,1510,8,115,10,115,12,115,1513,
        9,115,1,116,1,116,1,116,1,116,3,116,1519,8,116,1,117,1,117,1,117,
        1,117,3,117,1525,8,117,1,117,1,117,1,118,1,118,1,118,1,118,1,119,
        1,119,1,119,1,119,1,120,1,120,1,120,1,120,1,120,1,121,1,121,3,121,
        1544,8,121,1,121,1,121,1,122,1,122,1,122,1,122,1,122,1,123,1,123,
        3,123,1555,8,123,1,124,1,124,1,124,3,124,1560,8,124,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,3,125,1572,8,125,
        1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,
        1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,
        1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,
        1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,
        1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,
        1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,
        1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,1,126,
        1,126,1,126,1,126,1,126,1,126,1,126,1,126,3,126,1658,8,126,1,127,
        1,127,1,128,1,128,1,128,1,128,1,129,1,129,3,129,1668,8,129,1,130,
        1,130,1,130,1,130,1,131,1,131,1,131,1,131,1,132,1,132,3,132,1680,
        8,132,1,132,1,132,3,132,1684,8,132,3,132,1686,8,132,1,133,1,133,
        1,134,1,134,1,134,5,134,1693,8,134,10,134,12,134,1696,9,134,1,134,
        0,0,135,0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,
        42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,82,84,
        86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,120,
        122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,
        154,156,158,160,162,164,166,168,170,172,174,176,178,180,182,184,
        186,188,190,192,194,196,198,200,202,204,206,208,210,212,214,216,
        218,220,222,224,226,228,230,232,234,236,238,240,242,244,246,248,
        250,252,254,256,258,260,262,264,266,268,0,8,1,0,111,113,1,0,91,92,
        3,0,25,28,30,30,32,33,2,0,80,80,86,86,2,0,159,159,165,165,2,0,153,
        153,155,155,2,0,160,160,165,165,2,0,80,80,86,90,1800,0,273,1,0,0,
        0,2,275,1,0,0,0,4,287,1,0,0,0,6,296,1,0,0,0,8,300,1,0,0,0,10,302,
        1,0,0,0,12,310,1,0,0,0,14,312,1,0,0,0,16,319,1,0,0,0,18,377,1,0,
        0,0,20,379,1,0,0,0,22,387,1,0,0,0,24,399,1,0,0,0,26,403,1,0,0,0,
        28,405,1,0,0,0,30,410,1,0,0,0,32,414,1,0,0,0,34,424,1,0,0,0,36,431,
        1,0,0,0,38,433,1,0,0,0,40,441,1,0,0,0,42,453,1,0,0,0,44,455,1,0,
        0,0,46,463,1,0,0,0,48,471,1,0,0,0,50,473,1,0,0,0,52,487,1,0,0,0,
        54,507,1,0,0,0,56,509,1,0,0,0,58,525,1,0,0,0,60,539,1,0,0,0,62,541,
        1,0,0,0,64,547,1,0,0,0,66,549,1,0,0,0,68,553,1,0,0,0,70,557,1,0,
        0,0,72,565,1,0,0,0,74,567,1,0,0,0,76,572,1,0,0,0,78,577,1,0,0,0,
        80,582,1,0,0,0,82,587,1,0,0,0,84,592,1,0,0,0,86,597,1,0,0,0,88,604,
        1,0,0,0,90,611,1,0,0,0,92,618,1,0,0,0,94,625,1,0,0,0,96,632,1,0,
        0,0,98,639,1,0,0,0,100,651,1,0,0,0,102,653,1,0,0,0,104,661,1,0,0,
        0,106,665,1,0,0,0,108,669,1,0,0,0,110,676,1,0,0,0,112,680,1,0,0,
        0,114,687,1,0,0,0,116,689,1,0,0,0,118,704,1,0,0,0,120,790,1,0,0,
        0,122,792,1,0,0,0,124,805,1,0,0,0,126,807,1,0,0,0,128,815,1,0,0,
        0,130,819,1,0,0,0,132,823,1,0,0,0,134,831,1,0,0,0,136,835,1,0,0,
        0,138,839,1,0,0,0,140,846,1,0,0,0,142,850,1,0,0,0,144,857,1,0,0,
        0,146,966,1,0,0,0,148,968,1,0,0,0,150,981,1,0,0,0,152,983,1,0,0,
        0,154,991,1,0,0,0,156,995,1,0,0,0,158,999,1,0,0,0,160,1004,1,0,0,
        0,162,1008,1,0,0,0,164,1015,1,0,0,0,166,1019,1,0,0,0,168,1026,1,
        0,0,0,170,1139,1,0,0,0,172,1141,1,0,0,0,174,1154,1,0,0,0,176,1156,
        1,0,0,0,178,1164,1,0,0,0,180,1168,1,0,0,0,182,1172,1,0,0,0,184,1177,
        1,0,0,0,186,1181,1,0,0,0,188,1188,1,0,0,0,190,1192,1,0,0,0,192,1199,
        1,0,0,0,194,1312,1,0,0,0,196,1314,1,0,0,0,198,1327,1,0,0,0,200,1329,
        1,0,0,0,202,1337,1,0,0,0,204,1341,1,0,0,0,206,1345,1,0,0,0,208,1350,
        1,0,0,0,210,1354,1,0,0,0,212,1361,1,0,0,0,214,1365,1,0,0,0,216,1372,
        1,0,0,0,218,1471,1,0,0,0,220,1473,1,0,0,0,222,1481,1,0,0,0,224,1485,
        1,0,0,0,226,1489,1,0,0,0,228,1504,1,0,0,0,230,1506,1,0,0,0,232,1518,
        1,0,0,0,234,1520,1,0,0,0,236,1528,1,0,0,0,238,1532,1,0,0,0,240,1536,
        1,0,0,0,242,1543,1,0,0,0,244,1547,1,0,0,0,246,1554,1,0,0,0,248,1556,
        1,0,0,0,250,1571,1,0,0,0,252,1657,1,0,0,0,254,1659,1,0,0,0,256,1661,
        1,0,0,0,258,1667,1,0,0,0,260,1669,1,0,0,0,262,1673,1,0,0,0,264,1685,
        1,0,0,0,266,1687,1,0,0,0,268,1689,1,0,0,0,270,274,3,2,1,0,271,274,
        3,20,10,0,272,274,3,38,19,0,273,270,1,0,0,0,273,271,1,0,0,0,273,
        272,1,0,0,0,274,1,1,0,0,0,275,276,5,53,0,0,276,277,5,80,0,0,277,
        278,5,66,0,0,278,279,5,76,0,0,279,282,3,4,2,0,280,281,5,79,0,0,281,
        283,3,8,4,0,282,280,1,0,0,0,282,283,1,0,0,0,283,284,1,0,0,0,284,
        285,5,77,0,0,285,286,5,78,0,0,286,3,1,0,0,0,287,290,3,6,3,0,288,
        289,5,79,0,0,289,291,3,6,3,0,290,288,1,0,0,0,291,292,1,0,0,0,292,
        290,1,0,0,0,292,293,1,0,0,0,293,5,1,0,0,0,294,297,3,10,5,0,295,297,
        3,60,30,0,296,294,1,0,0,0,296,295,1,0,0,0,297,7,1,0,0,0,298,301,
        3,12,6,0,299,301,3,18,9,0,300,298,1,0,0,0,300,299,1,0,0,0,301,9,
        1,0,0,0,302,303,5,69,0,0,303,306,5,76,0,0,304,307,3,54,27,0,305,
        307,3,56,28,0,306,304,1,0,0,0,306,305,1,0,0,0,307,308,1,0,0,0,308,
        309,5,77,0,0,309,11,1,0,0,0,310,311,3,14,7,0,311,13,1,0,0,0,312,
        313,5,18,0,0,313,314,5,76,0,0,314,315,3,16,8,0,315,316,5,77,0,0,
        316,15,1,0,0,0,317,320,3,62,31,0,318,320,3,64,32,0,319,317,1,0,0,
        0,319,318,1,0,0,0,320,321,1,0,0,0,321,322,5,1,0,0,322,17,1,0,0,0,
        323,324,5,18,0,0,324,325,5,76,0,0,325,378,5,77,0,0,326,327,5,18,
        0,0,327,328,5,76,0,0,328,329,5,111,0,0,329,378,5,77,0,0,330,331,
        5,18,0,0,331,332,5,76,0,0,332,333,5,111,0,0,333,334,3,70,35,0,334,
        335,5,77,0,0,335,378,1,0,0,0,336,337,5,18,0,0,337,338,5,76,0,0,338,
        339,5,111,0,0,339,340,3,70,35,0,340,341,5,106,0,0,341,342,5,77,0,
        0,342,378,1,0,0,0,343,344,5,18,0,0,344,345,5,76,0,0,345,346,5,114,
        0,0,346,378,5,77,0,0,347,348,5,18,0,0,348,349,5,76,0,0,349,350,5,
        114,0,0,350,351,3,70,35,0,351,352,5,77,0,0,352,378,1,0,0,0,353,354,
        5,18,0,0,354,355,5,76,0,0,355,356,5,114,0,0,356,357,3,70,35,0,357,
        358,5,106,0,0,358,359,5,77,0,0,359,378,1,0,0,0,360,361,5,18,0,0,
        361,362,5,76,0,0,362,363,5,115,0,0,363,378,5,77,0,0,364,365,5,18,
        0,0,365,366,5,76,0,0,366,367,5,115,0,0,367,368,3,70,35,0,368,369,
        5,77,0,0,369,378,1,0,0,0,370,371,5,18,0,0,371,372,5,76,0,0,372,373,
        5,115,0,0,373,374,3,70,35,0,374,375,5,106,0,0,375,376,5,77,0,0,376,
        378,1,0,0,0,377,323,1,0,0,0,377,326,1,0,0,0,377,330,1,0,0,0,377,
        336,1,0,0,0,377,343,1,0,0,0,377,347,1,0,0,0,377,353,1,0,0,0,377,
        360,1,0,0,0,377,364,1,0,0,0,377,370,1,0,0,0,378,19,1,0,0,0,379,380,
        5,54,0,0,380,381,5,80,0,0,381,382,5,67,0,0,382,383,5,76,0,0,383,
        384,3,22,11,0,384,385,5,77,0,0,385,386,5,78,0,0,386,21,1,0,0,0,387,
        392,3,24,12,0,388,389,5,79,0,0,389,391,3,24,12,0,390,388,1,0,0,0,
        391,394,1,0,0,0,392,390,1,0,0,0,392,393,1,0,0,0,393,23,1,0,0,0,394,
        392,1,0,0,0,395,400,3,26,13,0,396,400,3,32,16,0,397,400,3,58,29,
        0,398,400,3,60,30,0,399,395,1,0,0,0,399,396,1,0,0,0,399,397,1,0,
        0,0,399,398,1,0,0,0,400,25,1,0,0,0,401,404,5,3,0,0,402,404,3,28,
        14,0,403,401,1,0,0,0,403,402,1,0,0,0,404,27,1,0,0,0,405,406,5,5,
        0,0,406,407,5,76,0,0,407,408,3,30,15,0,408,409,5,77,0,0,409,29,1,
        0,0,0,410,411,7,0,0,0,411,412,5,71,0,0,412,413,5,106,0,0,413,31,
        1,0,0,0,414,415,5,69,0,0,415,418,5,76,0,0,416,419,3,34,17,0,417,
        419,3,36,18,0,418,416,1,0,0,0,418,417,1,0,0,0,419,420,1,0,0,0,420,
        421,5,77,0,0,421,33,1,0,0,0,422,425,3,54,27,0,423,425,3,56,28,0,
        424,422,1,0,0,0,424,423,1,0,0,0,425,426,1,0,0,0,426,427,5,79,0,0,
        427,428,5,4,0,0,428,35,1,0,0,0,429,432,3,54,27,0,430,432,3,56,28,
        0,431,429,1,0,0,0,431,430,1,0,0,0,432,37,1,0,0,0,433,434,5,55,0,
        0,434,435,5,80,0,0,435,436,5,68,0,0,436,437,5,76,0,0,437,438,3,40,
        20,0,438,439,5,77,0,0,439,440,5,78,0,0,440,39,1,0,0,0,441,444,3,
        42,21,0,442,443,5,79,0,0,443,445,3,42,21,0,444,442,1,0,0,0,445,446,
        1,0,0,0,446,444,1,0,0,0,446,447,1,0,0,0,447,41,1,0,0,0,448,454,1,
        0,0,0,449,454,3,44,22,0,450,454,3,60,30,0,451,454,3,46,23,0,452,
        454,3,52,26,0,453,448,1,0,0,0,453,449,1,0,0,0,453,450,1,0,0,0,453,
        451,1,0,0,0,453,452,1,0,0,0,454,43,1,0,0,0,455,456,5,69,0,0,456,
        459,5,76,0,0,457,460,3,54,27,0,458,460,3,56,28,0,459,457,1,0,0,0,
        459,458,1,0,0,0,460,461,1,0,0,0,461,462,5,77,0,0,462,45,1,0,0,0,
        463,464,5,8,0,0,464,467,5,76,0,0,465,468,3,48,24,0,466,468,3,50,
        25,0,467,465,1,0,0,0,467,466,1,0,0,0,468,469,1,0,0,0,469,470,5,77,
        0,0,470,47,1,0,0,0,471,472,7,1,0,0,472,49,1,0,0,0,473,474,5,105,
        0,0,474,475,5,76,0,0,475,476,5,71,0,0,476,477,5,77,0,0,477,51,1,
        0,0,0,478,479,5,8,0,0,479,480,5,76,0,0,480,488,5,77,0,0,481,482,
        5,8,0,0,482,483,5,76,0,0,483,484,5,105,0,0,484,485,5,76,0,0,485,
        486,5,77,0,0,486,488,5,77,0,0,487,478,1,0,0,0,487,481,1,0,0,0,488,
        53,1,0,0,0,489,490,5,25,0,0,490,491,5,116,0,0,491,508,5,145,0,0,
        492,493,5,26,0,0,493,494,5,116,0,0,494,508,5,146,0,0,495,496,5,27,
        0,0,496,497,5,116,0,0,497,508,5,147,0,0,498,499,5,28,0,0,499,500,
        5,116,0,0,500,508,5,148,0,0,501,502,5,30,0,0,502,503,5,116,0,0,503,
        508,5,149,0,0,504,505,5,32,0,0,505,506,5,116,0,0,506,508,5,150,0,
        0,507,489,1,0,0,0,507,492,1,0,0,0,507,495,1,0,0,0,507,498,1,0,0,
        0,507,501,1,0,0,0,507,504,1,0,0,0,508,55,1,0,0,0,509,510,5,33,0,
        0,510,511,5,116,0,0,511,512,5,1,0,0,512,57,1,0,0,0,513,514,5,5,0,
        0,514,515,5,76,0,0,515,526,5,77,0,0,516,517,5,5,0,0,517,518,5,76,
        0,0,518,519,7,0,0,0,519,526,5,77,0,0,520,521,5,5,0,0,521,522,5,76,
        0,0,522,523,7,0,0,0,523,524,5,71,0,0,524,526,5,77,0,0,525,513,1,
        0,0,0,525,516,1,0,0,0,525,520,1,0,0,0,526,59,1,0,0,0,527,528,5,69,
        0,0,528,529,5,76,0,0,529,540,5,77,0,0,530,531,5,69,0,0,531,532,5,
        76,0,0,532,533,7,2,0,0,533,540,5,77,0,0,534,535,5,69,0,0,535,536,
        5,76,0,0,536,537,7,2,0,0,537,538,5,116,0,0,538,540,5,77,0,0,539,
        527,1,0,0,0,539,530,1,0,0,0,539,534,1,0,0,0,540,61,1,0,0,0,541,542,
        5,111,0,0,542,543,3,70,35,0,543,544,5,106,0,0,544,63,1,0,0,0,545,
        548,3,66,33,0,546,548,3,68,34,0,547,545,1,0,0,0,547,546,1,0,0,0,
        548,65,1,0,0,0,549,550,5,114,0,0,550,551,3,70,35,0,551,552,5,106,
        0,0,552,67,1,0,0,0,553,554,5,115,0,0,554,555,3,70,35,0,555,556,5,
        106,0,0,556,69,1,0,0,0,557,558,5,71,0,0,558,71,1,0,0,0,559,566,3,
        74,37,0,560,566,3,76,38,0,561,566,3,78,39,0,562,566,3,80,40,0,563,
        566,3,82,41,0,564,566,3,84,42,0,565,559,1,0,0,0,565,560,1,0,0,0,
        565,561,1,0,0,0,565,562,1,0,0,0,565,563,1,0,0,0,565,564,1,0,0,0,
        566,73,1,0,0,0,567,568,5,45,0,0,568,569,5,80,0,0,569,570,3,86,43,
        0,570,571,5,78,0,0,571,75,1,0,0,0,572,573,5,46,0,0,573,574,5,80,
        0,0,574,575,3,88,44,0,575,576,5,78,0,0,576,77,1,0,0,0,577,578,5,
        47,0,0,578,579,5,80,0,0,579,580,3,90,45,0,580,581,5,78,0,0,581,79,
        1,0,0,0,582,583,5,48,0,0,583,584,5,80,0,0,584,585,3,92,46,0,585,
        586,5,78,0,0,586,81,1,0,0,0,587,588,5,50,0,0,588,589,5,80,0,0,589,
        590,3,94,47,0,590,591,5,78,0,0,591,83,1,0,0,0,592,593,5,52,0,0,593,
        594,5,80,0,0,594,595,3,96,48,0,595,596,5,78,0,0,596,85,1,0,0,0,597,
        598,5,119,0,0,598,600,5,76,0,0,599,601,3,98,49,0,600,599,1,0,0,0,
        600,601,1,0,0,0,601,602,1,0,0,0,602,603,5,77,0,0,603,87,1,0,0,0,
        604,605,5,120,0,0,605,607,5,76,0,0,606,608,3,122,61,0,607,606,1,
        0,0,0,607,608,1,0,0,0,608,609,1,0,0,0,609,610,5,77,0,0,610,89,1,
        0,0,0,611,612,5,121,0,0,612,614,5,76,0,0,613,615,3,148,74,0,614,
        613,1,0,0,0,614,615,1,0,0,0,615,616,1,0,0,0,616,617,5,77,0,0,617,
        91,1,0,0,0,618,619,5,122,0,0,619,621,5,76,0,0,620,622,3,172,86,0,
        621,620,1,0,0,0,621,622,1,0,0,0,622,623,1,0,0,0,623,624,5,77,0,0,
        624,93,1,0,0,0,625,626,5,124,0,0,626,628,5,76,0,0,627,629,3,196,
        98,0,628,627,1,0,0,0,628,629,1,0,0,0,629,630,1,0,0,0,630,631,5,77,
        0,0,631,95,1,0,0,0,632,633,5,126,0,0,633,635,5,76,0,0,634,636,3,
        230,115,0,635,634,1,0,0,0,635,636,1,0,0,0,636,637,1,0,0,0,637,638,
        5,77,0,0,638,97,1,0,0,0,639,644,3,100,50,0,640,641,5,79,0,0,641,
        643,3,100,50,0,642,640,1,0,0,0,643,646,1,0,0,0,644,642,1,0,0,0,644,
        645,1,0,0,0,645,99,1,0,0,0,646,644,1,0,0,0,647,652,3,102,51,0,648,
        652,3,108,54,0,649,652,3,112,56,0,650,652,3,120,60,0,651,647,1,0,
        0,0,651,648,1,0,0,0,651,649,1,0,0,0,651,650,1,0,0,0,652,101,1,0,
        0,0,653,654,5,9,0,0,654,657,5,76,0,0,655,658,3,104,52,0,656,658,
        3,106,53,0,657,655,1,0,0,0,657,656,1,0,0,0,658,659,1,0,0,0,659,660,
        5,77,0,0,660,103,1,0,0,0,661,662,5,157,0,0,662,663,5,97,0,0,663,
        664,3,268,134,0,664,105,1,0,0,0,665,666,5,157,0,0,666,667,7,3,0,
        0,667,668,5,59,0,0,668,107,1,0,0,0,669,670,5,18,0,0,670,671,5,76,
        0,0,671,672,3,110,55,0,672,673,5,77,0,0,673,109,1,0,0,0,674,677,
        3,256,128,0,675,677,3,258,129,0,676,674,1,0,0,0,676,675,1,0,0,0,
        677,678,1,0,0,0,678,679,5,145,0,0,679,111,1,0,0,0,680,681,5,21,0,
        0,681,682,5,76,0,0,682,683,3,114,57,0,683,684,5,77,0,0,684,113,1,
        0,0,0,685,688,3,226,113,0,686,688,3,248,124,0,687,685,1,0,0,0,687,
        686,1,0,0,0,688,115,1,0,0,0,689,692,5,119,0,0,690,693,3,104,52,0,
        691,693,3,106,53,0,692,690,1,0,0,0,692,691,1,0,0,0,693,117,1,0,0,
        0,694,705,1,0,0,0,695,705,5,119,0,0,696,697,5,119,0,0,697,705,5,
        157,0,0,698,699,5,119,0,0,699,700,5,157,0,0,700,705,5,97,0,0,701,
        702,5,119,0,0,702,703,5,157,0,0,703,705,7,3,0,0,704,694,1,0,0,0,
        704,695,1,0,0,0,704,696,1,0,0,0,704,698,1,0,0,0,704,701,1,0,0,0,
        705,119,1,0,0,0,706,707,5,9,0,0,707,708,5,76,0,0,708,791,5,77,0,
        0,709,710,5,9,0,0,710,711,5,76,0,0,711,712,5,157,0,0,712,791,5,77,
        0,0,713,714,5,9,0,0,714,715,5,76,0,0,715,716,5,157,0,0,716,717,5,
        97,0,0,717,791,5,77,0,0,718,719,5,9,0,0,719,720,5,76,0,0,720,721,
        5,157,0,0,721,722,7,3,0,0,722,791,5,77,0,0,723,724,5,18,0,0,724,
        725,5,76,0,0,725,791,5,77,0,0,726,727,5,18,0,0,727,728,5,76,0,0,
        728,729,5,111,0,0,729,791,5,77,0,0,730,731,5,18,0,0,731,732,5,76,
        0,0,732,733,5,111,0,0,733,734,3,266,133,0,734,735,5,77,0,0,735,791,
        1,0,0,0,736,737,5,18,0,0,737,738,5,76,0,0,738,739,5,111,0,0,739,
        740,3,266,133,0,740,741,5,106,0,0,741,742,5,77,0,0,742,791,1,0,0,
        0,743,744,5,18,0,0,744,745,5,76,0,0,745,746,5,114,0,0,746,791,5,
        77,0,0,747,748,5,18,0,0,748,749,5,76,0,0,749,750,5,114,0,0,750,751,
        3,266,133,0,751,752,5,77,0,0,752,791,1,0,0,0,753,754,5,18,0,0,754,
        755,5,76,0,0,755,756,5,114,0,0,756,757,3,266,133,0,757,758,5,106,
        0,0,758,759,5,77,0,0,759,791,1,0,0,0,760,761,5,18,0,0,761,762,5,
        76,0,0,762,763,5,115,0,0,763,791,5,77,0,0,764,765,5,18,0,0,765,766,
        5,76,0,0,766,767,5,115,0,0,767,768,3,266,133,0,768,769,5,77,0,0,
        769,791,1,0,0,0,770,771,5,18,0,0,771,772,5,76,0,0,772,773,5,115,
        0,0,773,774,3,266,133,0,774,775,5,106,0,0,775,776,5,77,0,0,776,791,
        1,0,0,0,777,778,5,21,0,0,778,779,5,76,0,0,779,791,5,77,0,0,780,781,
        5,21,0,0,781,782,5,76,0,0,782,783,3,228,114,0,783,784,5,77,0,0,784,
        791,1,0,0,0,785,786,5,21,0,0,786,787,5,76,0,0,787,788,3,250,125,
        0,788,789,5,77,0,0,789,791,1,0,0,0,790,706,1,0,0,0,790,709,1,0,0,
        0,790,713,1,0,0,0,790,718,1,0,0,0,790,723,1,0,0,0,790,726,1,0,0,
        0,790,730,1,0,0,0,790,736,1,0,0,0,790,743,1,0,0,0,790,747,1,0,0,
        0,790,753,1,0,0,0,790,760,1,0,0,0,790,764,1,0,0,0,790,770,1,0,0,
        0,790,777,1,0,0,0,790,780,1,0,0,0,790,785,1,0,0,0,791,121,1,0,0,
        0,792,797,3,124,62,0,793,794,5,79,0,0,794,796,3,124,62,0,795,793,
        1,0,0,0,796,799,1,0,0,0,797,795,1,0,0,0,797,798,1,0,0,0,798,123,
        1,0,0,0,799,797,1,0,0,0,800,806,3,126,63,0,801,806,3,132,66,0,802,
        806,3,138,69,0,803,806,3,142,71,0,804,806,3,146,73,0,805,800,1,0,
        0,0,805,801,1,0,0,0,805,802,1,0,0,0,805,803,1,0,0,0,805,804,1,0,
        0,0,806,125,1,0,0,0,807,808,5,9,0,0,808,811,5,76,0,0,809,812,3,128,
        64,0,810,812,3,130,65,0,811,809,1,0,0,0,811,810,1,0,0,0,812,813,
        1,0,0,0,813,814,5,77,0,0,814,127,1,0,0,0,815,816,5,158,0,0,816,817,
        5,97,0,0,817,818,3,268,134,0,818,129,1,0,0,0,819,820,5,158,0,0,820,
        821,7,3,0,0,821,822,5,59,0,0,822,131,1,0,0,0,823,824,5,12,0,0,824,
        827,5,76,0,0,825,828,3,134,67,0,826,828,3,136,68,0,827,825,1,0,0,
        0,827,826,1,0,0,0,828,829,1,0,0,0,829,830,5,77,0,0,830,133,1,0,0,
        0,831,832,5,156,0,0,832,833,3,254,127,0,833,834,3,264,132,0,834,
        135,1,0,0,0,835,836,5,152,0,0,836,837,3,254,127,0,837,838,3,266,
        133,0,838,137,1,0,0,0,839,840,5,18,0,0,840,841,5,76,0,0,841,842,
        3,140,70,0,842,843,5,77,0,0,843,139,1,0,0,0,844,847,3,256,128,0,
        845,847,3,258,129,0,846,844,1,0,0,0,846,845,1,0,0,0,847,848,1,0,
        0,0,848,849,5,146,0,0,849,141,1,0,0,0,850,851,5,21,0,0,851,852,5,
        76,0,0,852,853,3,144,72,0,853,854,5,77,0,0,854,143,1,0,0,0,855,858,
        3,226,113,0,856,858,3,248,124,0,857,855,1,0,0,0,857,856,1,0,0,0,
        858,145,1,0,0,0,859,860,5,9,0,0,860,861,5,76,0,0,861,967,5,77,0,
        0,862,863,5,9,0,0,863,864,5,76,0,0,864,865,5,158,0,0,865,967,5,77,
        0,0,866,867,5,9,0,0,867,868,5,76,0,0,868,869,5,158,0,0,869,870,5,
        97,0,0,870,967,5,77,0,0,871,872,5,9,0,0,872,873,5,76,0,0,873,874,
        5,158,0,0,874,875,7,3,0,0,875,967,5,77,0,0,876,877,5,12,0,0,877,
        878,5,76,0,0,878,967,5,77,0,0,879,880,5,12,0,0,880,881,5,76,0,0,
        881,882,5,156,0,0,882,967,5,77,0,0,883,884,5,12,0,0,884,885,5,76,
        0,0,885,886,5,156,0,0,886,887,3,254,127,0,887,888,5,77,0,0,888,967,
        1,0,0,0,889,890,5,12,0,0,890,891,5,76,0,0,891,892,5,152,0,0,892,
        967,5,77,0,0,893,894,5,12,0,0,894,895,5,76,0,0,895,896,5,152,0,0,
        896,897,3,254,127,0,897,898,5,77,0,0,898,967,1,0,0,0,899,900,5,18,
        0,0,900,901,5,76,0,0,901,967,5,77,0,0,902,903,5,18,0,0,903,904,5,
        76,0,0,904,905,5,111,0,0,905,967,5,77,0,0,906,907,5,18,0,0,907,908,
        5,76,0,0,908,909,5,111,0,0,909,910,3,266,133,0,910,911,5,77,0,0,
        911,967,1,0,0,0,912,913,5,18,0,0,913,914,5,76,0,0,914,915,5,111,
        0,0,915,916,3,266,133,0,916,917,5,106,0,0,917,918,5,77,0,0,918,967,
        1,0,0,0,919,920,5,18,0,0,920,921,5,76,0,0,921,922,5,114,0,0,922,
        967,5,77,0,0,923,924,5,18,0,0,924,925,5,76,0,0,925,926,5,114,0,0,
        926,927,3,266,133,0,927,928,5,77,0,0,928,967,1,0,0,0,929,930,5,18,
        0,0,930,931,5,76,0,0,931,932,5,114,0,0,932,933,3,266,133,0,933,934,
        5,106,0,0,934,935,5,77,0,0,935,967,1,0,0,0,936,937,5,18,0,0,937,
        938,5,76,0,0,938,939,5,115,0,0,939,967,5,77,0,0,940,941,5,18,0,0,
        941,942,5,76,0,0,942,943,5,115,0,0,943,944,3,266,133,0,944,945,5,
        77,0,0,945,967,1,0,0,0,946,947,5,18,0,0,947,948,5,76,0,0,948,949,
        5,115,0,0,949,950,3,266,133,0,950,951,5,106,0,0,951,952,5,77,0,0,
        952,967,1,0,0,0,953,954,5,21,0,0,954,955,5,76,0,0,955,967,5,77,0,
        0,956,957,5,21,0,0,957,958,5,76,0,0,958,959,3,228,114,0,959,960,
        5,77,0,0,960,967,1,0,0,0,961,962,5,21,0,0,962,963,5,76,0,0,963,964,
        3,250,125,0,964,965,5,77,0,0,965,967,1,0,0,0,966,859,1,0,0,0,966,
        862,1,0,0,0,966,866,1,0,0,0,966,871,1,0,0,0,966,876,1,0,0,0,966,
        879,1,0,0,0,966,883,1,0,0,0,966,889,1,0,0,0,966,893,1,0,0,0,966,
        899,1,0,0,0,966,902,1,0,0,0,966,906,1,0,0,0,966,912,1,0,0,0,966,
        919,1,0,0,0,966,923,1,0,0,0,966,929,1,0,0,0,966,936,1,0,0,0,966,
        940,1,0,0,0,966,946,1,0,0,0,966,953,1,0,0,0,966,956,1,0,0,0,966,
        961,1,0,0,0,967,147,1,0,0,0,968,973,3,150,75,0,969,970,5,79,0,0,
        970,972,3,150,75,0,971,969,1,0,0,0,972,975,1,0,0,0,973,971,1,0,0,
        0,973,974,1,0,0,0,974,149,1,0,0,0,975,973,1,0,0,0,976,982,3,152,
        76,0,977,982,3,158,79,0,978,982,3,162,81,0,979,982,3,166,83,0,980,
        982,3,170,85,0,981,976,1,0,0,0,981,977,1,0,0,0,981,978,1,0,0,0,981,
        979,1,0,0,0,981,980,1,0,0,0,982,151,1,0,0,0,983,984,5,9,0,0,984,
        987,5,76,0,0,985,988,3,154,77,0,986,988,3,156,78,0,987,985,1,0,0,
        0,987,986,1,0,0,0,988,989,1,0,0,0,989,990,5,77,0,0,990,153,1,0,0,
        0,991,992,7,4,0,0,992,993,5,97,0,0,993,994,3,268,134,0,994,155,1,
        0,0,0,995,996,7,4,0,0,996,997,7,3,0,0,997,998,5,59,0,0,998,157,1,
        0,0,0,999,1000,5,12,0,0,1000,1001,5,76,0,0,1001,1002,3,160,80,0,
        1002,1003,5,77,0,0,1003,159,1,0,0,0,1004,1005,7,5,0,0,1005,1006,
        3,254,127,0,1006,1007,3,264,132,0,1007,161,1,0,0,0,1008,1009,5,18,
        0,0,1009,1010,5,76,0,0,1010,1011,3,164,82,0,1011,1012,5,77,0,0,1012,
        163,1,0,0,0,1013,1016,3,256,128,0,1014,1016,3,258,129,0,1015,1013,
        1,0,0,0,1015,1014,1,0,0,0,1016,1017,1,0,0,0,1017,1018,5,147,0,0,
        1018,165,1,0,0,0,1019,1020,5,21,0,0,1020,1021,5,76,0,0,1021,1022,
        3,168,84,0,1022,1023,5,77,0,0,1023,167,1,0,0,0,1024,1027,3,226,113,
        0,1025,1027,3,248,124,0,1026,1024,1,0,0,0,1026,1025,1,0,0,0,1027,
        169,1,0,0,0,1028,1029,5,9,0,0,1029,1030,5,76,0,0,1030,1140,5,77,
        0,0,1031,1032,5,9,0,0,1032,1033,5,76,0,0,1033,1034,5,159,0,0,1034,
        1140,5,77,0,0,1035,1036,5,9,0,0,1036,1037,5,76,0,0,1037,1038,5,159,
        0,0,1038,1039,5,97,0,0,1039,1140,5,77,0,0,1040,1041,5,9,0,0,1041,
        1042,5,76,0,0,1042,1043,5,159,0,0,1043,1044,7,3,0,0,1044,1140,5,
        77,0,0,1045,1046,5,9,0,0,1046,1047,5,76,0,0,1047,1048,5,165,0,0,
        1048,1140,5,77,0,0,1049,1050,5,9,0,0,1050,1051,5,76,0,0,1051,1052,
        5,165,0,0,1052,1053,5,97,0,0,1053,1140,5,77,0,0,1054,1055,5,9,0,
        0,1055,1056,5,76,0,0,1056,1057,5,165,0,0,1057,1058,7,3,0,0,1058,
        1140,5,77,0,0,1059,1060,5,12,0,0,1060,1061,5,76,0,0,1061,1140,5,
        77,0,0,1062,1063,5,12,0,0,1063,1064,5,76,0,0,1064,1065,7,5,0,0,1065,
        1140,5,77,0,0,1066,1067,5,12,0,0,1067,1068,5,76,0,0,1068,1069,7,
        5,0,0,1069,1070,3,254,127,0,1070,1071,5,77,0,0,1071,1140,1,0,0,0,
        1072,1073,5,18,0,0,1073,1074,5,76,0,0,1074,1140,5,77,0,0,1075,1076,
        5,18,0,0,1076,1077,5,76,0,0,1077,1078,5,111,0,0,1078,1140,5,77,0,
        0,1079,1080,5,18,0,0,1080,1081,5,76,0,0,1081,1082,5,111,0,0,1082,
        1083,3,266,133,0,1083,1084,5,77,0,0,1084,1140,1,0,0,0,1085,1086,
        5,18,0,0,1086,1087,5,76,0,0,1087,1088,5,111,0,0,1088,1089,3,266,
        133,0,1089,1090,5,106,0,0,1090,1091,5,77,0,0,1091,1140,1,0,0,0,1092,
        1093,5,18,0,0,1093,1094,5,76,0,0,1094,1095,5,114,0,0,1095,1140,5,
        77,0,0,1096,1097,5,18,0,0,1097,1098,5,76,0,0,1098,1099,5,114,0,0,
        1099,1100,3,266,133,0,1100,1101,5,77,0,0,1101,1140,1,0,0,0,1102,
        1103,5,18,0,0,1103,1104,5,76,0,0,1104,1105,5,114,0,0,1105,1106,3,
        266,133,0,1106,1107,5,106,0,0,1107,1108,5,77,0,0,1108,1140,1,0,0,
        0,1109,1110,5,18,0,0,1110,1111,5,76,0,0,1111,1112,5,115,0,0,1112,
        1140,5,77,0,0,1113,1114,5,18,0,0,1114,1115,5,76,0,0,1115,1116,5,
        115,0,0,1116,1117,3,266,133,0,1117,1118,5,77,0,0,1118,1140,1,0,0,
        0,1119,1120,5,18,0,0,1120,1121,5,76,0,0,1121,1122,5,115,0,0,1122,
        1123,3,266,133,0,1123,1124,5,106,0,0,1124,1125,5,77,0,0,1125,1140,
        1,0,0,0,1126,1127,5,21,0,0,1127,1128,5,76,0,0,1128,1140,5,77,0,0,
        1129,1130,5,21,0,0,1130,1131,5,76,0,0,1131,1132,3,228,114,0,1132,
        1133,5,77,0,0,1133,1140,1,0,0,0,1134,1135,5,21,0,0,1135,1136,5,76,
        0,0,1136,1137,3,250,125,0,1137,1138,5,77,0,0,1138,1140,1,0,0,0,1139,
        1028,1,0,0,0,1139,1031,1,0,0,0,1139,1035,1,0,0,0,1139,1040,1,0,0,
        0,1139,1045,1,0,0,0,1139,1049,1,0,0,0,1139,1054,1,0,0,0,1139,1059,
        1,0,0,0,1139,1062,1,0,0,0,1139,1066,1,0,0,0,1139,1072,1,0,0,0,1139,
        1075,1,0,0,0,1139,1079,1,0,0,0,1139,1085,1,0,0,0,1139,1092,1,0,0,
        0,1139,1096,1,0,0,0,1139,1102,1,0,0,0,1139,1109,1,0,0,0,1139,1113,
        1,0,0,0,1139,1119,1,0,0,0,1139,1126,1,0,0,0,1139,1129,1,0,0,0,1139,
        1134,1,0,0,0,1140,171,1,0,0,0,1141,1146,3,174,87,0,1142,1143,5,79,
        0,0,1143,1145,3,174,87,0,1144,1142,1,0,0,0,1145,1148,1,0,0,0,1146,
        1144,1,0,0,0,1146,1147,1,0,0,0,1147,173,1,0,0,0,1148,1146,1,0,0,
        0,1149,1155,3,176,88,0,1150,1155,3,182,91,0,1151,1155,3,186,93,0,
        1152,1155,3,190,95,0,1153,1155,3,194,97,0,1154,1149,1,0,0,0,1154,
        1150,1,0,0,0,1154,1151,1,0,0,0,1154,1152,1,0,0,0,1154,1153,1,0,0,
        0,1155,175,1,0,0,0,1156,1157,5,9,0,0,1157,1160,5,76,0,0,1158,1161,
        3,178,89,0,1159,1161,3,180,90,0,1160,1158,1,0,0,0,1160,1159,1,0,
        0,0,1161,1162,1,0,0,0,1162,1163,5,77,0,0,1163,177,1,0,0,0,1164,1165,
        7,6,0,0,1165,1166,5,97,0,0,1166,1167,3,268,134,0,1167,179,1,0,0,
        0,1168,1169,7,6,0,0,1169,1170,7,3,0,0,1170,1171,5,59,0,0,1171,181,
        1,0,0,0,1172,1173,5,12,0,0,1173,1174,5,76,0,0,1174,1175,3,184,92,
        0,1175,1176,5,77,0,0,1176,183,1,0,0,0,1177,1178,5,155,0,0,1178,1179,
        3,254,127,0,1179,1180,3,264,132,0,1180,185,1,0,0,0,1181,1182,5,18,
        0,0,1182,1183,5,76,0,0,1183,1184,3,188,94,0,1184,1185,5,77,0,0,1185,
        187,1,0,0,0,1186,1189,3,256,128,0,1187,1189,3,258,129,0,1188,1186,
        1,0,0,0,1188,1187,1,0,0,0,1189,1190,1,0,0,0,1190,1191,5,148,0,0,
        1191,189,1,0,0,0,1192,1193,5,21,0,0,1193,1194,5,76,0,0,1194,1195,
        3,192,96,0,1195,1196,5,77,0,0,1196,191,1,0,0,0,1197,1200,3,226,113,
        0,1198,1200,3,248,124,0,1199,1197,1,0,0,0,1199,1198,1,0,0,0,1200,
        193,1,0,0,0,1201,1202,5,9,0,0,1202,1203,5,76,0,0,1203,1313,5,77,
        0,0,1204,1205,5,9,0,0,1205,1206,5,76,0,0,1206,1207,5,160,0,0,1207,
        1313,5,77,0,0,1208,1209,5,9,0,0,1209,1210,5,76,0,0,1210,1211,5,160,
        0,0,1211,1212,5,97,0,0,1212,1313,5,77,0,0,1213,1214,5,9,0,0,1214,
        1215,5,76,0,0,1215,1216,5,160,0,0,1216,1217,7,3,0,0,1217,1313,5,
        77,0,0,1218,1219,5,9,0,0,1219,1220,5,76,0,0,1220,1221,5,165,0,0,
        1221,1313,5,77,0,0,1222,1223,5,9,0,0,1223,1224,5,76,0,0,1224,1225,
        5,165,0,0,1225,1226,5,97,0,0,1226,1313,5,77,0,0,1227,1228,5,9,0,
        0,1228,1229,5,76,0,0,1229,1230,5,165,0,0,1230,1231,7,3,0,0,1231,
        1313,5,77,0,0,1232,1233,5,12,0,0,1233,1234,5,76,0,0,1234,1313,5,
        77,0,0,1235,1236,5,12,0,0,1236,1237,5,76,0,0,1237,1238,5,155,0,0,
        1238,1313,5,77,0,0,1239,1240,5,12,0,0,1240,1241,5,76,0,0,1241,1242,
        5,155,0,0,1242,1243,3,254,127,0,1243,1244,5,77,0,0,1244,1313,1,0,
        0,0,1245,1246,5,18,0,0,1246,1247,5,76,0,0,1247,1313,5,77,0,0,1248,
        1249,5,18,0,0,1249,1250,5,76,0,0,1250,1251,5,111,0,0,1251,1313,5,
        77,0,0,1252,1253,5,18,0,0,1253,1254,5,76,0,0,1254,1255,5,111,0,0,
        1255,1256,3,266,133,0,1256,1257,5,77,0,0,1257,1313,1,0,0,0,1258,
        1259,5,18,0,0,1259,1260,5,76,0,0,1260,1261,5,111,0,0,1261,1262,3,
        266,133,0,1262,1263,5,106,0,0,1263,1264,5,77,0,0,1264,1313,1,0,0,
        0,1265,1266,5,18,0,0,1266,1267,5,76,0,0,1267,1268,5,114,0,0,1268,
        1313,5,77,0,0,1269,1270,5,18,0,0,1270,1271,5,76,0,0,1271,1272,5,
        114,0,0,1272,1273,3,266,133,0,1273,1274,5,77,0,0,1274,1313,1,0,0,
        0,1275,1276,5,18,0,0,1276,1277,5,76,0,0,1277,1278,5,114,0,0,1278,
        1279,3,266,133,0,1279,1280,5,106,0,0,1280,1281,5,77,0,0,1281,1313,
        1,0,0,0,1282,1283,5,18,0,0,1283,1284,5,76,0,0,1284,1285,5,115,0,
        0,1285,1313,5,77,0,0,1286,1287,5,18,0,0,1287,1288,5,76,0,0,1288,
        1289,5,115,0,0,1289,1290,3,266,133,0,1290,1291,5,77,0,0,1291,1313,
        1,0,0,0,1292,1293,5,18,0,0,1293,1294,5,76,0,0,1294,1295,5,115,0,
        0,1295,1296,3,266,133,0,1296,1297,5,106,0,0,1297,1298,5,77,0,0,1298,
        1313,1,0,0,0,1299,1300,5,21,0,0,1300,1301,5,76,0,0,1301,1313,5,77,
        0,0,1302,1303,5,21,0,0,1303,1304,5,76,0,0,1304,1305,3,228,114,0,
        1305,1306,5,77,0,0,1306,1313,1,0,0,0,1307,1308,5,21,0,0,1308,1309,
        5,76,0,0,1309,1310,3,250,125,0,1310,1311,5,77,0,0,1311,1313,1,0,
        0,0,1312,1201,1,0,0,0,1312,1204,1,0,0,0,1312,1208,1,0,0,0,1312,1213,
        1,0,0,0,1312,1218,1,0,0,0,1312,1222,1,0,0,0,1312,1227,1,0,0,0,1312,
        1232,1,0,0,0,1312,1235,1,0,0,0,1312,1239,1,0,0,0,1312,1245,1,0,0,
        0,1312,1248,1,0,0,0,1312,1252,1,0,0,0,1312,1258,1,0,0,0,1312,1265,
        1,0,0,0,1312,1269,1,0,0,0,1312,1275,1,0,0,0,1312,1282,1,0,0,0,1312,
        1286,1,0,0,0,1312,1292,1,0,0,0,1312,1299,1,0,0,0,1312,1302,1,0,0,
        0,1312,1307,1,0,0,0,1313,195,1,0,0,0,1314,1319,3,198,99,0,1315,1316,
        5,79,0,0,1316,1318,3,198,99,0,1317,1315,1,0,0,0,1318,1321,1,0,0,
        0,1319,1317,1,0,0,0,1319,1320,1,0,0,0,1320,197,1,0,0,0,1321,1319,
        1,0,0,0,1322,1328,3,200,100,0,1323,1328,3,206,103,0,1324,1328,3,
        210,105,0,1325,1328,3,214,107,0,1326,1328,3,218,109,0,1327,1322,
        1,0,0,0,1327,1323,1,0,0,0,1327,1324,1,0,0,0,1327,1325,1,0,0,0,1327,
        1326,1,0,0,0,1328,199,1,0,0,0,1329,1330,5,9,0,0,1330,1333,5,76,0,
        0,1331,1334,3,202,101,0,1332,1334,3,204,102,0,1333,1331,1,0,0,0,
        1333,1332,1,0,0,0,1334,1335,1,0,0,0,1335,1336,5,77,0,0,1336,201,
        1,0,0,0,1337,1338,5,162,0,0,1338,1339,5,97,0,0,1339,1340,3,268,134,
        0,1340,203,1,0,0,0,1341,1342,5,162,0,0,1342,1343,7,3,0,0,1343,1344,
        5,59,0,0,1344,205,1,0,0,0,1345,1346,5,12,0,0,1346,1347,5,76,0,0,
        1347,1348,3,208,104,0,1348,1349,5,77,0,0,1349,207,1,0,0,0,1350,1351,
        5,156,0,0,1351,1352,3,254,127,0,1352,1353,3,266,133,0,1353,209,1,
        0,0,0,1354,1355,5,18,0,0,1355,1356,5,76,0,0,1356,1357,3,212,106,
        0,1357,1358,5,77,0,0,1358,211,1,0,0,0,1359,1362,3,256,128,0,1360,
        1362,3,258,129,0,1361,1359,1,0,0,0,1361,1360,1,0,0,0,1362,1363,1,
        0,0,0,1363,1364,5,149,0,0,1364,213,1,0,0,0,1365,1366,5,21,0,0,1366,
        1367,5,76,0,0,1367,1368,3,216,108,0,1368,1369,5,77,0,0,1369,215,
        1,0,0,0,1370,1373,3,226,113,0,1371,1373,3,248,124,0,1372,1370,1,
        0,0,0,1372,1371,1,0,0,0,1373,217,1,0,0,0,1374,1375,5,9,0,0,1375,
        1376,5,76,0,0,1376,1472,5,77,0,0,1377,1378,5,9,0,0,1378,1379,5,76,
        0,0,1379,1380,5,162,0,0,1380,1472,5,77,0,0,1381,1382,5,9,0,0,1382,
        1383,5,76,0,0,1383,1384,5,162,0,0,1384,1385,5,97,0,0,1385,1472,5,
        77,0,0,1386,1387,5,9,0,0,1387,1388,5,76,0,0,1388,1389,5,162,0,0,
        1389,1390,7,3,0,0,1390,1472,5,77,0,0,1391,1392,5,12,0,0,1392,1393,
        5,76,0,0,1393,1472,5,77,0,0,1394,1395,5,12,0,0,1395,1396,5,76,0,
        0,1396,1397,5,156,0,0,1397,1472,5,77,0,0,1398,1399,5,12,0,0,1399,
        1400,5,76,0,0,1400,1401,5,156,0,0,1401,1402,3,254,127,0,1402,1403,
        5,77,0,0,1403,1472,1,0,0,0,1404,1405,5,18,0,0,1405,1406,5,76,0,0,
        1406,1472,5,77,0,0,1407,1408,5,18,0,0,1408,1409,5,76,0,0,1409,1410,
        5,111,0,0,1410,1472,5,77,0,0,1411,1412,5,18,0,0,1412,1413,5,76,0,
        0,1413,1414,5,111,0,0,1414,1415,3,266,133,0,1415,1416,5,77,0,0,1416,
        1472,1,0,0,0,1417,1418,5,18,0,0,1418,1419,5,76,0,0,1419,1420,5,111,
        0,0,1420,1421,3,266,133,0,1421,1422,5,106,0,0,1422,1423,5,77,0,0,
        1423,1472,1,0,0,0,1424,1425,5,18,0,0,1425,1426,5,76,0,0,1426,1427,
        5,114,0,0,1427,1472,5,77,0,0,1428,1429,5,18,0,0,1429,1430,5,76,0,
        0,1430,1431,5,114,0,0,1431,1432,3,266,133,0,1432,1433,5,77,0,0,1433,
        1472,1,0,0,0,1434,1435,5,18,0,0,1435,1436,5,76,0,0,1436,1437,5,114,
        0,0,1437,1438,3,266,133,0,1438,1439,5,106,0,0,1439,1440,5,77,0,0,
        1440,1472,1,0,0,0,1441,1442,5,18,0,0,1442,1443,5,76,0,0,1443,1444,
        5,115,0,0,1444,1472,5,77,0,0,1445,1446,5,18,0,0,1446,1447,5,76,0,
        0,1447,1448,5,115,0,0,1448,1449,3,266,133,0,1449,1450,5,77,0,0,1450,
        1472,1,0,0,0,1451,1452,5,18,0,0,1452,1453,5,76,0,0,1453,1454,5,115,
        0,0,1454,1455,3,266,133,0,1455,1456,5,106,0,0,1456,1457,5,77,0,0,
        1457,1472,1,0,0,0,1458,1459,5,21,0,0,1459,1460,5,76,0,0,1460,1472,
        5,77,0,0,1461,1462,5,21,0,0,1462,1463,5,76,0,0,1463,1464,3,228,114,
        0,1464,1465,5,77,0,0,1465,1472,1,0,0,0,1466,1467,5,21,0,0,1467,1468,
        5,76,0,0,1468,1469,3,250,125,0,1469,1470,5,77,0,0,1470,1472,1,0,
        0,0,1471,1374,1,0,0,0,1471,1377,1,0,0,0,1471,1381,1,0,0,0,1471,1386,
        1,0,0,0,1471,1391,1,0,0,0,1471,1394,1,0,0,0,1471,1398,1,0,0,0,1471,
        1404,1,0,0,0,1471,1407,1,0,0,0,1471,1411,1,0,0,0,1471,1417,1,0,0,
        0,1471,1424,1,0,0,0,1471,1428,1,0,0,0,1471,1434,1,0,0,0,1471,1441,
        1,0,0,0,1471,1445,1,0,0,0,1471,1451,1,0,0,0,1471,1458,1,0,0,0,1471,
        1461,1,0,0,0,1471,1466,1,0,0,0,1472,219,1,0,0,0,1473,1474,5,9,0,
        0,1474,1477,5,76,0,0,1475,1478,3,222,111,0,1476,1478,3,224,112,0,
        1477,1475,1,0,0,0,1477,1476,1,0,0,0,1478,1479,1,0,0,0,1479,1480,
        5,77,0,0,1480,221,1,0,0,0,1481,1482,5,163,0,0,1482,1483,5,97,0,0,
        1483,1484,3,268,134,0,1484,223,1,0,0,0,1485,1486,5,163,0,0,1486,
        1487,7,3,0,0,1487,1488,5,59,0,0,1488,225,1,0,0,0,1489,1492,5,125,
        0,0,1490,1493,3,222,111,0,1491,1493,3,224,112,0,1492,1490,1,0,0,
        0,1492,1491,1,0,0,0,1493,227,1,0,0,0,1494,1505,1,0,0,0,1495,1505,
        5,125,0,0,1496,1497,5,125,0,0,1497,1505,5,163,0,0,1498,1499,5,125,
        0,0,1499,1500,5,163,0,0,1500,1505,5,97,0,0,1501,1502,5,125,0,0,1502,
        1503,5,163,0,0,1503,1505,7,3,0,0,1504,1494,1,0,0,0,1504,1495,1,0,
        0,0,1504,1496,1,0,0,0,1504,1498,1,0,0,0,1504,1501,1,0,0,0,1505,229,
        1,0,0,0,1506,1511,3,232,116,0,1507,1508,5,79,0,0,1508,1510,3,232,
        116,0,1509,1507,1,0,0,0,1510,1513,1,0,0,0,1511,1509,1,0,0,0,1511,
        1512,1,0,0,0,1512,231,1,0,0,0,1513,1511,1,0,0,0,1514,1519,3,234,
        117,0,1515,1519,3,240,120,0,1516,1519,3,244,122,0,1517,1519,3,252,
        126,0,1518,1514,1,0,0,0,1518,1515,1,0,0,0,1518,1516,1,0,0,0,1518,
        1517,1,0,0,0,1519,233,1,0,0,0,1520,1521,5,9,0,0,1521,1524,5,76,0,
        0,1522,1525,3,236,118,0,1523,1525,3,238,119,0,1524,1522,1,0,0,0,
        1524,1523,1,0,0,0,1525,1526,1,0,0,0,1526,1527,5,77,0,0,1527,235,
        1,0,0,0,1528,1529,5,164,0,0,1529,1530,5,97,0,0,1530,1531,3,268,134,
        0,1531,237,1,0,0,0,1532,1533,5,164,0,0,1533,1534,7,3,0,0,1534,1535,
        5,59,0,0,1535,239,1,0,0,0,1536,1537,5,18,0,0,1537,1538,5,76,0,0,
        1538,1539,3,242,121,0,1539,1540,5,77,0,0,1540,241,1,0,0,0,1541,1544,
        3,256,128,0,1542,1544,3,258,129,0,1543,1541,1,0,0,0,1543,1542,1,
        0,0,0,1544,1545,1,0,0,0,1545,1546,5,150,0,0,1546,243,1,0,0,0,1547,
        1548,5,21,0,0,1548,1549,5,76,0,0,1549,1550,3,246,123,0,1550,1551,
        5,77,0,0,1551,245,1,0,0,0,1552,1555,3,226,113,0,1553,1555,3,116,
        58,0,1554,1552,1,0,0,0,1554,1553,1,0,0,0,1555,247,1,0,0,0,1556,1559,
        5,126,0,0,1557,1560,3,236,118,0,1558,1560,3,238,119,0,1559,1557,
        1,0,0,0,1559,1558,1,0,0,0,1560,249,1,0,0,0,1561,1572,1,0,0,0,1562,
        1572,5,126,0,0,1563,1564,5,126,0,0,1564,1572,5,164,0,0,1565,1566,
        5,126,0,0,1566,1567,5,164,0,0,1567,1572,5,97,0,0,1568,1569,5,126,
        0,0,1569,1570,5,164,0,0,1570,1572,7,3,0,0,1571,1561,1,0,0,0,1571,
        1562,1,0,0,0,1571,1563,1,0,0,0,1571,1565,1,0,0,0,1571,1568,1,0,0,
        0,1572,251,1,0,0,0,1573,1574,5,9,0,0,1574,1575,5,76,0,0,1575,1658,
        5,77,0,0,1576,1577,5,9,0,0,1577,1578,5,76,0,0,1578,1579,5,164,0,
        0,1579,1658,5,77,0,0,1580,1581,5,9,0,0,1581,1582,5,76,0,0,1582,1583,
        5,164,0,0,1583,1584,5,97,0,0,1584,1658,5,77,0,0,1585,1586,5,9,0,
        0,1586,1587,5,76,0,0,1587,1588,5,164,0,0,1588,1589,7,3,0,0,1589,
        1658,5,77,0,0,1590,1591,5,18,0,0,1591,1592,5,76,0,0,1592,1658,5,
        77,0,0,1593,1594,5,18,0,0,1594,1595,5,76,0,0,1595,1596,5,111,0,0,
        1596,1658,5,77,0,0,1597,1598,5,18,0,0,1598,1599,5,76,0,0,1599,1600,
        5,111,0,0,1600,1601,3,266,133,0,1601,1602,5,77,0,0,1602,1658,1,0,
        0,0,1603,1604,5,18,0,0,1604,1605,5,76,0,0,1605,1606,5,111,0,0,1606,
        1607,3,266,133,0,1607,1608,5,106,0,0,1608,1609,5,77,0,0,1609,1658,
        1,0,0,0,1610,1611,5,18,0,0,1611,1612,5,76,0,0,1612,1613,5,114,0,
        0,1613,1658,5,77,0,0,1614,1615,5,18,0,0,1615,1616,5,76,0,0,1616,
        1617,5,114,0,0,1617,1618,3,266,133,0,1618,1619,5,77,0,0,1619,1658,
        1,0,0,0,1620,1621,5,18,0,0,1621,1622,5,76,0,0,1622,1623,5,114,0,
        0,1623,1624,3,266,133,0,1624,1625,5,106,0,0,1625,1626,5,77,0,0,1626,
        1658,1,0,0,0,1627,1628,5,18,0,0,1628,1629,5,76,0,0,1629,1630,5,115,
        0,0,1630,1658,5,77,0,0,1631,1632,5,18,0,0,1632,1633,5,76,0,0,1633,
        1634,5,115,0,0,1634,1635,3,266,133,0,1635,1636,5,77,0,0,1636,1658,
        1,0,0,0,1637,1638,5,18,0,0,1638,1639,5,76,0,0,1639,1640,5,115,0,
        0,1640,1641,3,266,133,0,1641,1642,5,106,0,0,1642,1643,5,77,0,0,1643,
        1658,1,0,0,0,1644,1645,5,21,0,0,1645,1646,5,76,0,0,1646,1658,5,77,
        0,0,1647,1648,5,21,0,0,1648,1649,5,76,0,0,1649,1650,3,228,114,0,
        1650,1651,5,77,0,0,1651,1658,1,0,0,0,1652,1653,5,21,0,0,1653,1654,
        5,76,0,0,1654,1655,3,118,59,0,1655,1656,5,77,0,0,1656,1658,1,0,0,
        0,1657,1573,1,0,0,0,1657,1576,1,0,0,0,1657,1580,1,0,0,0,1657,1585,
        1,0,0,0,1657,1590,1,0,0,0,1657,1593,1,0,0,0,1657,1597,1,0,0,0,1657,
        1603,1,0,0,0,1657,1610,1,0,0,0,1657,1614,1,0,0,0,1657,1620,1,0,0,
        0,1657,1627,1,0,0,0,1657,1631,1,0,0,0,1657,1637,1,0,0,0,1657,1644,
        1,0,0,0,1657,1647,1,0,0,0,1657,1652,1,0,0,0,1658,253,1,0,0,0,1659,
        1660,7,7,0,0,1660,255,1,0,0,0,1661,1662,5,111,0,0,1662,1663,3,266,
        133,0,1663,1664,5,106,0,0,1664,257,1,0,0,0,1665,1668,3,260,130,0,
        1666,1668,3,262,131,0,1667,1665,1,0,0,0,1667,1666,1,0,0,0,1668,259,
        1,0,0,0,1669,1670,5,114,0,0,1670,1671,3,266,133,0,1671,1672,5,106,
        0,0,1672,261,1,0,0,0,1673,1674,5,115,0,0,1674,1675,3,266,133,0,1675,
        1676,5,106,0,0,1676,263,1,0,0,0,1677,1686,3,266,133,0,1678,1680,
        5,71,0,0,1679,1678,1,0,0,0,1679,1680,1,0,0,0,1680,1681,1,0,0,0,1681,
        1683,5,116,0,0,1682,1684,5,71,0,0,1683,1682,1,0,0,0,1683,1684,1,
        0,0,0,1684,1686,1,0,0,0,1685,1677,1,0,0,0,1685,1679,1,0,0,0,1686,
        265,1,0,0,0,1687,1688,5,71,0,0,1688,267,1,0,0,0,1689,1694,5,43,0,
        0,1690,1691,5,79,0,0,1691,1693,5,43,0,0,1692,1690,1,0,0,0,1693,1696,
        1,0,0,0,1694,1692,1,0,0,0,1694,1695,1,0,0,0,1695,269,1,0,0,0,1696,
        1694,1,0,0,0,79,273,282,292,296,300,306,319,377,392,399,403,418,
        424,431,446,453,459,467,487,507,525,539,547,565,600,607,614,621,
        628,635,644,651,657,676,687,692,704,790,797,805,811,827,846,857,
        966,973,981,987,1015,1026,1139,1146,1154,1160,1188,1199,1312,1319,
        1327,1333,1361,1372,1471,1477,1492,1504,1511,1518,1524,1543,1554,
        1559,1571,1657,1667,1679,1683,1685,1694
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!DerivedEvents.__ATN) {
            DerivedEvents.__ATN = new antlr.ATNDeserializer().deserialize(DerivedEvents._serializedATN);
        }

        return DerivedEvents.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(DerivedEvents.literalNames, DerivedEvents.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return DerivedEvents.vocabulary;
    }

    private static readonly decisionsToDFA = DerivedEvents._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}

export class Derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event(): Merged_eventContext | null {
        return this.getRuleContext(0, Merged_eventContext);
    }
    public sequence_event(): Sequence_eventContext | null {
        return this.getRuleContext(0, Sequence_eventContext);
    }
    public instance_event(): Instance_eventContext | null {
        return this.getRuleContext(0, Instance_eventContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_derived_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDerived_event) {
             listener.enterDerived_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDerived_event) {
             listener.exitDerived_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDerived_event) {
            return visitor.visitDerived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MERGED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.MERGED_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.EQ, 0)!;
    }
    public MERGED_EVENT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.MERGED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        return this.getRuleContext(0, Merged_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEMICOLON, 0)!;
    }
    public COMMA(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMA, 0);
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext | null {
        return this.getRuleContext(0, Merged_event_filter_criterionContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_merged_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMerged_event) {
             listener.enterMerged_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMerged_event) {
             listener.exitMerged_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMerged_event) {
            return visitor.visitMerged_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_criterion(): Merged_event_criterionContext[];
    public merged_event_criterion(i: number): Merged_event_criterionContext | null;
    public merged_event_criterion(i?: number): Merged_event_criterionContext[] | Merged_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Merged_event_criterionContext);
        }

        return this.getRuleContext(i, Merged_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_merged_event_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMerged_event_criteria) {
             listener.enterMerged_event_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMerged_event_criteria) {
             listener.exitMerged_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criteria) {
            return visitor.visitMerged_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_event(): Merged_event_eventContext | null {
        return this.getRuleContext(0, Merged_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_merged_event_criterion;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMerged_event_criterion) {
             listener.enterMerged_event_criterion(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMerged_event_criterion) {
             listener.exitMerged_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criterion) {
            return visitor.visitMerged_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_filter(): Merged_event_filterContext | null {
        return this.getRuleContext(0, Merged_event_filterContext);
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext | null {
        return this.getRuleContext(0, Merged_event_filter_errorContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_merged_event_filter_criterion;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMerged_event_filter_criterion) {
             listener.enterMerged_event_filter_criterion(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMerged_event_filter_criterion) {
             listener.exitMerged_event_filter_criterion(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_criterion) {
            return visitor.visitMerged_event_filter_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_merged_event_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMerged_event_event) {
             listener.enterMerged_event_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMerged_event_event) {
             listener.exitMerged_event_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_event) {
            return visitor.visitMerged_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filterContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_merged_event_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMerged_event_filter) {
             listener.enterMerged_event_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMerged_event_filter) {
             listener.exitMerged_event_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter) {
            return visitor.visitMerged_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filter_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_merged_event_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMerged_event_uniqueness_filter) {
             listener.enterMerged_event_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMerged_event_uniqueness_filter) {
             listener.exitMerged_event_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter) {
            return visitor.visitMerged_event_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filter_criteriaContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DERIVED_EVENT_DATE, 0)!;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filterContext);
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_merged_event_uniqueness_filter_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMerged_event_uniqueness_filter_criteria) {
             listener.enterMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMerged_event_uniqueness_filter_criteria) {
             listener.exitMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter_criteria) {
            return visitor.visitMerged_event_uniqueness_filter_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0);
    }
    public derived_event_int(): Derived_event_intContext | null {
        return this.getRuleContext(0, Derived_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.ROLLING_WINDOW, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_merged_event_filter_error;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMerged_event_filter_error) {
             listener.enterMerged_event_filter_error(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMerged_event_filter_error) {
             listener.exitMerged_event_filter_error(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_error) {
            return visitor.visitMerged_event_filter_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SEQUENCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEQUENCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.EQ, 0)!;
    }
    public SEQUENCE_EVENT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEQUENCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        return this.getRuleContext(0, Sequence_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_sequence_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSequence_event) {
             listener.enterSequence_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSequence_event) {
             listener.exitSequence_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSequence_event) {
            return visitor.visitSequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_criterion(): Sequence_event_criterionContext[];
    public sequence_event_criterion(i: number): Sequence_event_criterionContext | null;
    public sequence_event_criterion(i?: number): Sequence_event_criterionContext[] | Sequence_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Sequence_event_criterionContext);
        }

        return this.getRuleContext(i, Sequence_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_sequence_event_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSequence_event_criteria) {
             listener.enterSequence_event_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSequence_event_criteria) {
             listener.exitSequence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criteria) {
            return visitor.visitSequence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_constraint(): Sequence_event_constraintContext | null {
        return this.getRuleContext(0, Sequence_event_constraintContext);
    }
    public sequence_event_event(): Sequence_event_eventContext | null {
        return this.getRuleContext(0, Sequence_event_eventContext);
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext | null {
        return this.getRuleContext(0, Sequence_event_constraint_errorContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_sequence_event_criterion;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSequence_event_criterion) {
             listener.enterSequence_event_criterion(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSequence_event_criterion) {
             listener.exitSequence_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criterion) {
            return visitor.visitSequence_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ANY_ORDER(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.ANY_ORDER, 0);
    }
    public temporal_constraint(): Temporal_constraintContext | null {
        return this.getRuleContext(0, Temporal_constraintContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_sequence_event_constraint;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSequence_event_constraint) {
             listener.enterSequence_event_constraint(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSequence_event_constraint) {
             listener.exitSequence_event_constraint(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint) {
            return visitor.visitSequence_event_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Temporal_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        return this.getRuleContext(0, Sequence_temporal_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_temporal_constraint;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterTemporal_constraint) {
             listener.enterTemporal_constraint(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitTemporal_constraint) {
             listener.exitTemporal_constraint(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitTemporal_constraint) {
            return visitor.visitTemporal_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_temporal_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.INT, 0)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.TIME_UNIT, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.TOTAL_BETWEEN, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_sequence_temporal_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSequence_temporal_filter) {
             listener.enterSequence_temporal_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSequence_temporal_filter) {
             listener.exitSequence_temporal_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSequence_temporal_filter) {
            return visitor.visitSequence_temporal_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public selected_sequence_event(): Selected_sequence_eventContext | null {
        return this.getRuleContext(0, Selected_sequence_eventContext);
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext | null {
        return this.getRuleContext(0, Unselected_sequence_eventContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_sequence_event_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSequence_event_event) {
             listener.enterSequence_event_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSequence_event_event) {
             listener.exitSequence_event_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_event) {
            return visitor.visitSequence_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Selected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.COMMA, 0)!;
    }
    public IS_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.IS_EVENT_DATE, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_selected_sequence_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSelected_sequence_event) {
             listener.enterSelected_sequence_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSelected_sequence_event) {
             listener.exitSelected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSelected_sequence_event) {
            return visitor.visitSelected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Unselected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_unselected_sequence_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterUnselected_sequence_event) {
             listener.enterUnselected_sequence_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitUnselected_sequence_event) {
             listener.exitUnselected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitUnselected_sequence_event) {
            return visitor.visitUnselected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INSTANCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.INSTANCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.EQ, 0)!;
    }
    public INSTANCE_EVENT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.INSTANCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        return this.getRuleContext(0, Instance_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_instance_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterInstance_event) {
             listener.enterInstance_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitInstance_event) {
             listener.exitInstance_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitInstance_event) {
            return visitor.visitInstance_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_criterion(): Instance_event_criterionContext[];
    public instance_event_criterion(i: number): Instance_event_criterionContext | null;
    public instance_event_criterion(i?: number): Instance_event_criterionContext[] | Instance_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Instance_event_criterionContext);
        }

        return this.getRuleContext(i, Instance_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_instance_event_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterInstance_event_criteria) {
             listener.enterInstance_event_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitInstance_event_criteria) {
             listener.exitInstance_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criteria) {
            return visitor.visitInstance_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_event(): Instance_event_eventContext | null {
        return this.getRuleContext(0, Instance_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public instance_event_position(): Instance_event_positionContext | null {
        return this.getRuleContext(0, Instance_event_positionContext);
    }
    public instance_event_position_error(): Instance_event_position_errorContext | null {
        return this.getRuleContext(0, Instance_event_position_errorContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_instance_event_criterion;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterInstance_event_criterion) {
             listener.enterInstance_event_criterion(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitInstance_event_criterion) {
             listener.exitInstance_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criterion) {
            return visitor.visitInstance_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_instance_event_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterInstance_event_event) {
             listener.enterInstance_event_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitInstance_event_event) {
             listener.exitInstance_event_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_event) {
            return visitor.visitInstance_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_positionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext | null {
        return this.getRuleContext(0, Aggregation_qualifiedContext);
    }
    public specific_instance(): Specific_instanceContext | null {
        return this.getRuleContext(0, Specific_instanceContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_instance_event_position;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterInstance_event_position) {
             listener.enterInstance_event_position(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitInstance_event_position) {
             listener.exitInstance_event_position(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position) {
            return visitor.visitInstance_event_position(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Aggregation_qualifiedContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MAX(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MAX, 0);
    }
    public MIN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MIN, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_aggregation_qualified;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterAggregation_qualified) {
             listener.enterAggregation_qualified(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitAggregation_qualified) {
             listener.exitAggregation_qualified(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitAggregation_qualified) {
            return visitor.visitAggregation_qualified(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Specific_instanceContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.INDEX, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.INT, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_specific_instance;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSpecific_instance) {
             listener.enterSpecific_instance(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSpecific_instance) {
             listener.exitSpecific_instance(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSpecific_instance) {
            return visitor.visitSpecific_instance(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_position_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode[];
    public OPEN_PAREN(i: number): antlr.TerminalNode | null;
    public OPEN_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.OPEN_PAREN);
    	} else {
    		return this.getToken(DerivedEvents.OPEN_PAREN, i);
    	}
    }
    public CLOSE_PAREN(): antlr.TerminalNode[];
    public CLOSE_PAREN(i: number): antlr.TerminalNode | null;
    public CLOSE_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.CLOSE_PAREN);
    	} else {
    		return this.getToken(DerivedEvents.CLOSE_PAREN, i);
    	}
    }
    public INDEX(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.INDEX, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_instance_event_position_error;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterInstance_event_position_error) {
             listener.enterInstance_event_position_error(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitInstance_event_position_error) {
             listener.exitInstance_event_position_error(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position_error) {
            return visitor.visitInstance_event_position_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PERIOD, 0)!;
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MEASUREMENT_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.OBSERVATION_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_qualified_simple_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterQualified_simple_event) {
             listener.enterQualified_simple_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitQualified_simple_event) {
             listener.exitQualified_simple_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitQualified_simple_event) {
            return visitor.visitQualified_simple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.QUALIFIED_DERIVED_EVENT_NAME, 0)!;
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PERIOD, 0)!;
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DERIVED_EVENT_DATE, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_qualified_derived_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterQualified_derived_event) {
             listener.enterQualified_derived_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitQualified_derived_event) {
             listener.exitQualified_derived_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitQualified_derived_event) {
            return visitor.visitQualified_derived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraint_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.TOTAL_BETWEEN, 0);
    }
    public INT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.INT, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_sequence_event_constraint_error;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSequence_event_constraint_error) {
             listener.enterSequence_event_constraint_error(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSequence_event_constraint_error) {
             listener.exitSequence_event_constraint_error(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint_error) {
            return visitor.visitSequence_event_constraint_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUALIFIED_DERIVED_EVENT_NAME, 0);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.PERIOD, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_derived_event_error;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDerived_event_error) {
             listener.enterDerived_event_error(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDerived_event_error) {
             listener.exitDerived_event_error(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_error) {
            return visitor.visitDerived_event_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_derived_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDerived_uniqueness_filter) {
             listener.enterDerived_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDerived_uniqueness_filter) {
             listener.exitDerived_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter) {
            return visitor.visitDerived_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_fixed_window_uniqueness_filterContext);
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_derived_uniqueness_filter_window;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDerived_uniqueness_filter_window) {
             listener.enterDerived_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDerived_uniqueness_filter_window) {
             listener.exitDerived_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter_window) {
            return visitor.visitDerived_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.FIXED_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_derived_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDerived_fixed_window_uniqueness_filter) {
             listener.enterDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDerived_fixed_window_uniqueness_filter) {
             listener.exitDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDerived_fixed_window_uniqueness_filter) {
            return visitor.visitDerived_fixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.ROLLING_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_derived_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDerived_rolling_window_uniqueness_filter) {
             listener.enterDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDerived_rolling_window_uniqueness_filter) {
             listener.exitDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDerived_rolling_window_uniqueness_filter) {
            return visitor.visitDerived_rolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_derived_event_int;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDerived_event_int) {
             listener.enterDerived_event_int(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDerived_event_int) {
             listener.exitDerived_event_int(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_int) {
            return visitor.visitDerived_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext | null {
        return this.getRuleContext(0, Condition_occurrence_eventContext);
    }
    public drug_exposure_event(): Drug_exposure_eventContext | null {
        return this.getRuleContext(0, Drug_exposure_eventContext);
    }
    public measurement_event(): Measurement_eventContext | null {
        return this.getRuleContext(0, Measurement_eventContext);
    }
    public observation_event(): Observation_eventContext | null {
        return this.getRuleContext(0, Observation_eventContext);
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext | null {
        return this.getRuleContext(0, Procedure_occurrence_eventContext);
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext | null {
        return this.getRuleContext(0, Visit_occurrence_eventContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_simple_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSimple_event) {
             listener.enterSimple_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSimple_event) {
             listener.exitSimple_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_event) {
            return visitor.visitSimple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Condition_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEMICOLON, 0)!;
    }
    public CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE_ALIAS, 0)!;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        return this.getRuleContext(0, Condition_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_event) {
             listener.enterCondition_occurrence_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_event) {
             listener.exitCondition_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event) {
            return visitor.visitCondition_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Drug_exposure_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEMICOLON, 0)!;
    }
    public DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DRUG_EXPOSURE_ALIAS, 0)!;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        return this.getRuleContext(0, Drug_exposure_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_event) {
             listener.enterDrug_exposure_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_event) {
             listener.exitDrug_exposure_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event) {
            return visitor.visitDrug_exposure_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Measurement_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEMICOLON, 0)!;
    }
    public MEASUREMENT_ALIAS(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.MEASUREMENT_ALIAS, 0)!;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        return this.getRuleContext(0, Measurement_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_event) {
             listener.enterMeasurement_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_event) {
             listener.exitMeasurement_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event) {
            return visitor.visitMeasurement_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Observation_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEMICOLON, 0)!;
    }
    public OBSERVATION_ALIAS(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OBSERVATION_ALIAS, 0)!;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        return this.getRuleContext(0, Observation_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_event) {
             listener.enterObservation_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_event) {
             listener.exitObservation_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_event) {
            return visitor.visitObservation_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Procedure_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEMICOLON, 0)!;
    }
    public PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PROCEDURE_OCCURRENCE_ALIAS, 0)!;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        return this.getRuleContext(0, Procedure_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_event) {
             listener.enterProcedure_occurrence_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_event) {
             listener.exitProcedure_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event) {
            return visitor.visitProcedure_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Visit_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.SEMICOLON, 0)!;
    }
    public VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE_ALIAS, 0)!;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        return this.getRuleContext(0, Visit_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_event;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_event) {
             listener.enterVisit_occurrence_event(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_event) {
             listener.exitVisit_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event) {
            return visitor.visitVisit_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Condition_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Condition_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_event_definition;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_event_definition) {
             listener.enterCondition_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_event_definition) {
             listener.exitCondition_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_definition) {
            return visitor.visitCondition_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Drug_exposure_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DRUG_EXPOSURE, 0)!;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext | null {
        return this.getRuleContext(0, Drug_exposure_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_event_definition;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_event_definition) {
             listener.enterDrug_exposure_event_definition(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_event_definition) {
             listener.exitDrug_exposure_event_definition(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_definition) {
            return visitor.visitDrug_exposure_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Measurement_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.MEASUREMENT, 0)!;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext | null {
        return this.getRuleContext(0, Measurement_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_event_definition;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_event_definition) {
             listener.enterMeasurement_event_definition(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_event_definition) {
             listener.exitMeasurement_event_definition(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_definition) {
            return visitor.visitMeasurement_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Observation_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OBSERVATION, 0)!;
    }
    public observation_event_criteria(): Observation_event_criteriaContext | null {
        return this.getRuleContext(0, Observation_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_event_definition;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_event_definition) {
             listener.enterObservation_event_definition(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_event_definition) {
             listener.exitObservation_event_definition(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_definition) {
            return visitor.visitObservation_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Procedure_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PROCEDURE_OCCURRENCE, 0)!;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Procedure_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_event_definition;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_event_definition) {
             listener.enterProcedure_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_event_definition) {
             listener.exitProcedure_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_definition) {
            return visitor.visitProcedure_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Visit_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Visit_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_event_definition;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_event_definition) {
             listener.enterVisit_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_event_definition) {
             listener.exitVisit_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_definition) {
            return visitor.visitVisit_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext[];
    public condition_occurrence_event_filter(i: number): Condition_occurrence_event_filterContext | null;
    public condition_occurrence_event_filter(i?: number): Condition_occurrence_event_filterContext[] | Condition_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Condition_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Condition_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_event_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_event_criteria) {
             listener.enterCondition_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_event_criteria) {
             listener.exitCondition_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_criteria) {
            return visitor.visitCondition_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filtersContext);
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filtersContext);
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filtersContext);
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_event_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_event_filter) {
             listener.enterCondition_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_event_filter) {
             listener.exitCondition_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_filter) {
            return visitor.visitCondition_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_concept_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_concept_filters) {
             listener.enterCondition_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_concept_filters) {
             listener.exitCondition_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filters) {
            return visitor.visitCondition_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_concept_group_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_concept_group_filter) {
             listener.enterCondition_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_concept_group_filter) {
             listener.exitCondition_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_group_filter) {
            return visitor.visitCondition_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_concept_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_concept_filter) {
             listener.enterCondition_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_concept_filter) {
             listener.exitCondition_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filter) {
            return visitor.visitCondition_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filters) {
             listener.enterCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filters) {
             listener.exitCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filters) {
            return visitor.visitCondition_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filter) {
             listener.enterCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filter) {
             listener.exitCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filter) {
            return visitor.visitCondition_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_related_entity_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_related_entity_filters) {
             listener.enterCondition_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_related_entity_filters) {
             listener.exitCondition_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filters) {
            return visitor.visitCondition_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_related_entity_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_related_entity_filter) {
             listener.enterCondition_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_related_entity_filter) {
             listener.exitCondition_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filter) {
            return visitor.visitCondition_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_sub_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_sub_filter) {
             listener.enterCondition_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_sub_filter) {
             listener.exitCondition_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_sub_filter) {
            return visitor.visitCondition_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE, 0);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_error_sub_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_error_sub_filter) {
             listener.enterCondition_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_error_sub_filter) {
             listener.exitCondition_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_sub_filter) {
            return visitor.visitCondition_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_condition_occurrence_error_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterCondition_occurrence_error_filter) {
             listener.enterCondition_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitCondition_occurrence_error_filter) {
             listener.exitCondition_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_filter) {
            return visitor.visitCondition_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext[];
    public drug_exposure_event_filter(i: number): Drug_exposure_event_filterContext | null;
    public drug_exposure_event_filter(i?: number): Drug_exposure_event_filterContext[] | Drug_exposure_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Drug_exposure_event_filterContext);
        }

        return this.getRuleContext(i, Drug_exposure_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_event_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_event_criteria) {
             listener.enterDrug_exposure_event_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_event_criteria) {
             listener.exitDrug_exposure_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_criteria) {
            return visitor.visitDrug_exposure_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filtersContext);
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_numeric_filtersContext);
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filtersContext);
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_related_entity_filtersContext);
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_error_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_event_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_event_filter) {
             listener.enterDrug_exposure_event_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_event_filter) {
             listener.exitDrug_exposure_event_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_filter) {
            return visitor.visitDrug_exposure_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_group_filterContext);
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_concept_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_concept_filters) {
             listener.enterDrug_exposure_concept_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_concept_filters) {
             listener.exitDrug_exposure_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filters) {
            return visitor.visitDrug_exposure_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_concept_group_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_concept_group_filter) {
             listener.enterDrug_exposure_concept_group_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_concept_group_filter) {
             listener.exitDrug_exposure_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_group_filter) {
            return visitor.visitDrug_exposure_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_concept_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_concept_filter) {
             listener.enterDrug_exposure_concept_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_concept_filter) {
             listener.exitDrug_exposure_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filter) {
            return visitor.visitDrug_exposure_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_float_filterContext);
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_int_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_numeric_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_numeric_filters) {
             listener.enterDrug_exposure_numeric_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_numeric_filters) {
             listener.exitDrug_exposure_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_numeric_filters) {
            return visitor.visitDrug_exposure_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_float_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_float_filter) {
             listener.enterDrug_exposure_float_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_float_filter) {
             listener.exitDrug_exposure_float_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_float_filter) {
            return visitor.visitDrug_exposure_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DRUG_EXPOSURE_INT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_int_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_int_filter) {
             listener.enterDrug_exposure_int_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_int_filter) {
             listener.exitDrug_exposure_int_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_int_filter) {
            return visitor.visitDrug_exposure_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_uniqueness_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_uniqueness_filters) {
             listener.enterDrug_exposure_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_uniqueness_filters) {
             listener.exitDrug_exposure_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filters) {
            return visitor.visitDrug_exposure_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_uniqueness_filter) {
             listener.enterDrug_exposure_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_uniqueness_filter) {
             listener.exitDrug_exposure_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filter) {
            return visitor.visitDrug_exposure_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        return this.getRuleContext(0, Drug_exposure_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_related_entity_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_related_entity_filters) {
             listener.enterDrug_exposure_related_entity_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_related_entity_filters) {
             listener.exitDrug_exposure_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filters) {
            return visitor.visitDrug_exposure_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_related_entity_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_related_entity_filter) {
             listener.enterDrug_exposure_related_entity_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_related_entity_filter) {
             listener.exitDrug_exposure_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filter) {
            return visitor.visitDrug_exposure_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.DRUG_EXPOSURE_INT_ATTRIBUTE, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_drug_exposure_error_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterDrug_exposure_error_filter) {
             listener.enterDrug_exposure_error_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitDrug_exposure_error_filter) {
             listener.exitDrug_exposure_error_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_error_filter) {
            return visitor.visitDrug_exposure_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_event_filter(): Measurement_event_filterContext[];
    public measurement_event_filter(i: number): Measurement_event_filterContext | null;
    public measurement_event_filter(i?: number): Measurement_event_filterContext[] | Measurement_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Measurement_event_filterContext);
        }

        return this.getRuleContext(i, Measurement_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_event_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_event_criteria) {
             listener.enterMeasurement_event_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_event_criteria) {
             listener.exitMeasurement_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_criteria) {
            return visitor.visitMeasurement_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext | null {
        return this.getRuleContext(0, Measurement_concept_filtersContext);
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext | null {
        return this.getRuleContext(0, Measurement_numeric_filtersContext);
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Measurement_uniqueness_filtersContext);
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext | null {
        return this.getRuleContext(0, Measurement_related_entity_filtersContext);
    }
    public measurement_error_filter(): Measurement_error_filterContext | null {
        return this.getRuleContext(0, Measurement_error_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_event_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_event_filter) {
             listener.enterMeasurement_event_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_event_filter) {
             listener.exitMeasurement_event_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_filter) {
            return visitor.visitMeasurement_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_group_filterContext);
    }
    public measurement_concept_filter(): Measurement_concept_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_concept_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_concept_filters) {
             listener.enterMeasurement_concept_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_concept_filters) {
             listener.exitMeasurement_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filters) {
            return visitor.visitMeasurement_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_concept_group_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_concept_group_filter) {
             listener.enterMeasurement_concept_group_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_concept_group_filter) {
             listener.exitMeasurement_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_group_filter) {
            return visitor.visitMeasurement_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONCEPT, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_concept_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_concept_filter) {
             listener.enterMeasurement_concept_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_concept_filter) {
             listener.exitMeasurement_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filter) {
            return visitor.visitMeasurement_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        return this.getRuleContext(0, Measurement_float_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_numeric_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_numeric_filters) {
             listener.enterMeasurement_numeric_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_numeric_filters) {
             listener.exitMeasurement_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_numeric_filters) {
            return visitor.visitMeasurement_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_float_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_float_filter) {
             listener.enterMeasurement_float_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_float_filter) {
             listener.exitMeasurement_float_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_float_filter) {
            return visitor.visitMeasurement_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        return this.getRuleContext(0, Measurement_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_uniqueness_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_uniqueness_filters) {
             listener.enterMeasurement_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_uniqueness_filters) {
             listener.exitMeasurement_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filters) {
            return visitor.visitMeasurement_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.MEASUREMENT_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_uniqueness_filter) {
             listener.enterMeasurement_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_uniqueness_filter) {
             listener.exitMeasurement_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filter) {
            return visitor.visitMeasurement_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        return this.getRuleContext(0, Measurement_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_related_entity_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_related_entity_filters) {
             listener.enterMeasurement_related_entity_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_related_entity_filters) {
             listener.exitMeasurement_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filters) {
            return visitor.visitMeasurement_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_related_entity_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_related_entity_filter) {
             listener.enterMeasurement_related_entity_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_related_entity_filter) {
             listener.exitMeasurement_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filter) {
            return visitor.visitMeasurement_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NF, 0);
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_measurement_error_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterMeasurement_error_filter) {
             listener.enterMeasurement_error_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitMeasurement_error_filter) {
             listener.exitMeasurement_error_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_error_filter) {
            return visitor.visitMeasurement_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_event_filter(): Observation_event_filterContext[];
    public observation_event_filter(i: number): Observation_event_filterContext | null;
    public observation_event_filter(i?: number): Observation_event_filterContext[] | Observation_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Observation_event_filterContext);
        }

        return this.getRuleContext(i, Observation_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_event_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_event_criteria) {
             listener.enterObservation_event_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_event_criteria) {
             listener.exitObservation_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_criteria) {
            return visitor.visitObservation_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_concept_filters(): Observation_concept_filtersContext | null {
        return this.getRuleContext(0, Observation_concept_filtersContext);
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext | null {
        return this.getRuleContext(0, Observation_numeric_filtersContext);
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Observation_uniqueness_filtersContext);
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext | null {
        return this.getRuleContext(0, Observation_related_entity_filtersContext);
    }
    public observation_error_filter(): Observation_error_filterContext | null {
        return this.getRuleContext(0, Observation_error_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_event_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_event_filter) {
             listener.enterObservation_event_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_event_filter) {
             listener.exitObservation_event_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_filter) {
            return visitor.visitObservation_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext | null {
        return this.getRuleContext(0, Observation_concept_group_filterContext);
    }
    public observation_concept_filter(): Observation_concept_filterContext | null {
        return this.getRuleContext(0, Observation_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_concept_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_concept_filters) {
             listener.enterObservation_concept_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_concept_filters) {
             listener.exitObservation_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filters) {
            return visitor.visitObservation_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_concept_group_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_concept_group_filter) {
             listener.enterObservation_concept_group_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_concept_group_filter) {
             listener.exitObservation_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_group_filter) {
            return visitor.visitObservation_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONCEPT, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_concept_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_concept_filter) {
             listener.enterObservation_concept_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_concept_filter) {
             listener.exitObservation_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filter) {
            return visitor.visitObservation_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public observation_float_filter(): Observation_float_filterContext | null {
        return this.getRuleContext(0, Observation_float_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_numeric_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_numeric_filters) {
             listener.enterObservation_numeric_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_numeric_filters) {
             listener.exitObservation_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_numeric_filters) {
            return visitor.visitObservation_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_float_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_float_filter) {
             listener.enterObservation_float_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_float_filter) {
             listener.exitObservation_float_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_float_filter) {
            return visitor.visitObservation_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        return this.getRuleContext(0, Observation_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_uniqueness_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_uniqueness_filters) {
             listener.enterObservation_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_uniqueness_filters) {
             listener.exitObservation_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filters) {
            return visitor.visitObservation_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OBSERVATION_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_uniqueness_filter) {
             listener.enterObservation_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_uniqueness_filter) {
             listener.exitObservation_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filter) {
            return visitor.visitObservation_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        return this.getRuleContext(0, Observation_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_related_entity_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_related_entity_filters) {
             listener.enterObservation_related_entity_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_related_entity_filters) {
             listener.exitObservation_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filters) {
            return visitor.visitObservation_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_related_entity_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_related_entity_filter) {
             listener.enterObservation_related_entity_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_related_entity_filter) {
             listener.exitObservation_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filter) {
            return visitor.visitObservation_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NF, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_observation_error_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterObservation_error_filter) {
             listener.enterObservation_error_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitObservation_error_filter) {
             listener.exitObservation_error_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitObservation_error_filter) {
            return visitor.visitObservation_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext[];
    public procedure_occurrence_event_filter(i: number): Procedure_occurrence_event_filterContext | null;
    public procedure_occurrence_event_filter(i?: number): Procedure_occurrence_event_filterContext[] | Procedure_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Procedure_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Procedure_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_event_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_event_criteria) {
             listener.enterProcedure_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_event_criteria) {
             listener.exitProcedure_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_criteria) {
            return visitor.visitProcedure_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filtersContext);
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_numeric_filtersContext);
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filtersContext);
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filtersContext);
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_event_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_event_filter) {
             listener.enterProcedure_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_event_filter) {
             listener.exitProcedure_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_filter) {
            return visitor.visitProcedure_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_group_filterContext);
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_concept_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_concept_filters) {
             listener.enterProcedure_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_concept_filters) {
             listener.exitProcedure_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filters) {
            return visitor.visitProcedure_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_concept_group_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_concept_group_filter) {
             listener.enterProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_concept_group_filter) {
             listener.exitProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_group_filter) {
            return visitor.visitProcedure_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_concept_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_concept_filter) {
             listener.enterProcedure_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_concept_filter) {
             listener.exitProcedure_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filter) {
            return visitor.visitProcedure_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_int_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_numeric_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_numeric_filters) {
             listener.enterProcedure_occurrence_numeric_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_numeric_filters) {
             listener.exitProcedure_occurrence_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_numeric_filters) {
            return visitor.visitProcedure_occurrence_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_int_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_int_filter) {
             listener.enterProcedure_occurrence_int_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_int_filter) {
             listener.exitProcedure_occurrence_int_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_int_filter) {
            return visitor.visitProcedure_occurrence_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filters) {
             listener.enterProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filters) {
             listener.exitProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filters) {
            return visitor.visitProcedure_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filter) {
             listener.enterProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filter) {
             listener.exitProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filter) {
            return visitor.visitProcedure_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_related_entity_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filters) {
             listener.enterProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filters) {
             listener.exitProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filters) {
            return visitor.visitProcedure_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_related_entity_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filter) {
             listener.enterProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filter) {
             listener.exitProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filter) {
            return visitor.visitProcedure_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_procedure_occurrence_error_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProcedure_occurrence_error_filter) {
             listener.enterProcedure_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProcedure_occurrence_error_filter) {
             listener.exitProcedure_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_error_filter) {
            return visitor.visitProcedure_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_provider_concept_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProvider_concept_filters) {
             listener.enterProvider_concept_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProvider_concept_filters) {
             listener.exitProvider_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filters) {
            return visitor.visitProvider_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_provider_concept_group_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProvider_concept_group_filter) {
             listener.enterProvider_concept_group_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProvider_concept_group_filter) {
             listener.exitProvider_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_group_filter) {
            return visitor.visitProvider_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_provider_concept_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProvider_concept_filter) {
             listener.enterProvider_concept_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProvider_concept_filter) {
             listener.exitProvider_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filter) {
            return visitor.visitProvider_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.PROVIDER, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_provider_sub_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProvider_sub_filter) {
             listener.enterProvider_sub_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProvider_sub_filter) {
             listener.exitProvider_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_sub_filter) {
            return visitor.visitProvider_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.PROVIDER, 0);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.PROVIDER_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_provider_error_sub_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterProvider_error_sub_filter) {
             listener.enterProvider_error_sub_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitProvider_error_sub_filter) {
             listener.exitProvider_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitProvider_error_sub_filter) {
            return visitor.visitProvider_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext[];
    public visit_occurrence_event_filter(i: number): Visit_occurrence_event_filterContext | null;
    public visit_occurrence_event_filter(i?: number): Visit_occurrence_event_filterContext[] | Visit_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Visit_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Visit_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_event_criteria;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_event_criteria) {
             listener.enterVisit_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_event_criteria) {
             listener.exitVisit_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_criteria) {
            return visitor.visitVisit_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filtersContext);
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filtersContext);
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filtersContext);
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_event_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_event_filter) {
             listener.enterVisit_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_event_filter) {
             listener.exitVisit_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_filter) {
            return visitor.visitVisit_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_concept_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_concept_filters) {
             listener.enterVisit_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_concept_filters) {
             listener.exitVisit_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filters) {
            return visitor.visitVisit_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_concept_group_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_concept_group_filter) {
             listener.enterVisit_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_concept_group_filter) {
             listener.exitVisit_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_group_filter) {
            return visitor.visitVisit_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_concept_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_concept_filter) {
             listener.enterVisit_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_concept_filter) {
             listener.exitVisit_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filter) {
            return visitor.visitVisit_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filters) {
             listener.enterVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filters) {
             listener.exitVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filters) {
            return visitor.visitVisit_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filter) {
             listener.enterVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filter) {
             listener.exitVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filter) {
            return visitor.visitVisit_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_related_entity_filters;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_related_entity_filters) {
             listener.enterVisit_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_related_entity_filters) {
             listener.exitVisit_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filters) {
            return visitor.visitVisit_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_related_entity_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_related_entity_filter) {
             listener.enterVisit_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_related_entity_filter) {
             listener.exitVisit_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filter) {
            return visitor.visitVisit_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_sub_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_sub_filter) {
             listener.enterVisit_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_sub_filter) {
             listener.exitVisit_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_sub_filter) {
            return visitor.visitVisit_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE, 0);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_error_sub_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_error_sub_filter) {
             listener.enterVisit_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_error_sub_filter) {
             listener.exitVisit_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_sub_filter) {
            return visitor.visitVisit_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_visit_occurrence_error_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterVisit_occurrence_error_filter) {
             listener.enterVisit_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitVisit_occurrence_error_filter) {
             listener.exitVisit_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_filter) {
            return visitor.visitVisit_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Comparison_opContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.EQ, 0);
    }
    public LT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.LT, 0);
    }
    public GT(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.GT, 0);
    }
    public LTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.LTE, 0);
    }
    public GTE(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.GTE, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_comparison_op;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterComparison_op) {
             listener.enterComparison_op(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitComparison_op) {
             listener.exitComparison_op(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitComparison_op) {
            return visitor.visitComparison_op(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.MINIMUM_BETWEEN, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_simple_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSimple_uniqueness_filter) {
             listener.enterSimple_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSimple_uniqueness_filter) {
             listener.exitSimple_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter) {
            return visitor.visitSimple_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Fixed_window_uniqueness_filterContext);
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_simple_uniqueness_filter_window;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSimple_uniqueness_filter_window) {
             listener.enterSimple_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSimple_uniqueness_filter_window) {
             listener.exitSimple_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter_window) {
            return visitor.visitSimple_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.FIXED_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterFixed_window_uniqueness_filter) {
             listener.enterFixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitFixed_window_uniqueness_filter) {
             listener.exitFixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitFixed_window_uniqueness_filter) {
            return visitor.visitFixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.ROLLING_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterRolling_window_uniqueness_filter) {
             listener.enterRolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitRolling_window_uniqueness_filter) {
             listener.exitRolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitRolling_window_uniqueness_filter) {
            return visitor.visitRolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_floatContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(DerivedEvents.PERIOD, 0);
    }
    public INT(): antlr.TerminalNode[];
    public INT(i: number): antlr.TerminalNode | null;
    public INT(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.INT);
    	} else {
    		return this.getToken(DerivedEvents.INT, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_simple_event_float;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSimple_event_float) {
             listener.enterSimple_event_float(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSimple_event_float) {
             listener.exitSimple_event_float(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_float) {
            return visitor.visitSimple_event_float(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(DerivedEvents.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_simple_event_int;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterSimple_event_int) {
             listener.enterSimple_event_int(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitSimple_event_int) {
             listener.exitSimple_event_int(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_int) {
            return visitor.visitSimple_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Concept_group_selectionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT_GROUP(): antlr.TerminalNode[];
    public CONCEPT_GROUP(i: number): antlr.TerminalNode | null;
    public CONCEPT_GROUP(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.CONCEPT_GROUP);
    	} else {
    		return this.getToken(DerivedEvents.CONCEPT_GROUP, i);
    	}
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(DerivedEvents.COMMA);
    	} else {
    		return this.getToken(DerivedEvents.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return DerivedEvents.RULE_concept_group_selection;
    }
    public override enterRule(listener: DerivedEventsListener): void {
        if(listener.enterConcept_group_selection) {
             listener.enterConcept_group_selection(this);
        }
    }
    public override exitRule(listener: DerivedEventsListener): void {
        if(listener.exitConcept_group_selection) {
             listener.exitConcept_group_selection(this);
        }
    }
    public override accept<Result>(visitor: DerivedEventsVisitor<Result>): Result | null {
        if (visitor.visitConcept_group_selection) {
            return visitor.visitConcept_group_selection(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
